<template>
    <div class="parent" :class="{ parent_correction: feeClicked }">
        <MobileHeader @toggleSidebarParent="toggleSidebarParent" />
        <SideBar
            :is-open="isSidebarOpen"
            @toggleSidebarParentClose="toggleSidebarParentClose"
            @questionRoullette="questionRoullette"
        />

        <div class="wrapper" :class="{ shadow: shadow }">
            <div v-if="pageLoad" class="main-div opacity0" :class="{ opacity1: loadHeader }">
                <div class="mobile-header">
                    <img src="@/assets/arrow-back.svg" alt="back icon" @click="backInner" />

                    <div v-if="tournament.created_by_name && loaded" class="flexend-mobile">
                        <div
                            v-if="
                                (!tournament.event_is_corporate ||
                                    tournament.event_uuid !== 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b') &&
                                !registerForm &&
                                !registerFormCompany &&
                                tournament.registration &&
                                registerOk &&
                                new Date(tournament.event_date_to) >= new Date() - 86400000
                            "
                            class="confirm-button2-cream flex-center"
                            @click="register()"
                        >
                            <p>Register</p>
                        </div>
                        <router-link
                            :to="{
                                name: 'ParticipantsList',
                                params: { id: tournament.event_uuid },
                            }"
                        >
                            <div
                                v-if="
                                    !registerForm &&
                                    (!registerFormCompany ||
                                        tournament.event_uuid !== 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b') &&
                                    tournament.players_total > 0 &&
                                    !registerOk
                                "
                                class="confirm-button2 flex-center"
                            >
                                <p>Participants</p>
                            </div>
                            <div
                                v-if="
                                    !registerForm &&
                                    (!registerFormCompany ||
                                        tournament.event_uuid !== 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b') &&
                                    tournament.players_total > 0 &&
                                    registerOk &&
                                    !tournament.event_is_corporate
                                "
                                class="confirm-button2 flex-center"
                            >
                                <p>Participants</p>
                            </div>
                        </router-link>
                    </div>

                    <!-- <Notifications /> -->
                </div>
                <div class="bottom">
                    <div class="row-one" @click="backInner">
                        <img src="../../assets/arrow-back.svg" alt="back icon" />
                        <!--  <p>Tournament Calendar</p>-->
                    </div>

                    <div v-if="!logedIn && !registerForm && !registerFormCompany" class="row-one-second">
                        <p>Sign up and explore many other events on the Outpost Calendar now!</p>
                    </div>

                    <div v-if="!registerForm && !registerFormCompany" class="row-two">
                        <div v-if="loadTournament && loaded" style="display: block">
                            <div>
                                <ShareTournament :tournament="tournament" />
                            </div>
                            <h2 class="no-edit">
                                {{ tournament.event_name }}
                            </h2>
                            <div v-if="tournament.created_by">
                                <p v-if="tournament.created_by_name" class="organizer-name">
                                    Organizer:
                                    <router-link
                                        :to="{
                                            name: 'Publicprofile',
                                            params: { id: tournament.created_by },
                                        }"
                                    >
                                        <span class="blue opacity">
                                            {{ tournament.created_by_name }}
                                            {{ tournament.created_by_last_name }}
                                        </span>
                                    </router-link>
                                </p>
                            </div>
                            <div v-if="tournament.created_by">
                                <p v-if="tournament.prize_pool">
                                    Prize pool:
                                    <span class="color-brown">{{ currency }}{{ tournament.prize_pool }} </span>
                                </p>
                            </div>
                            <div
                                class="players-registred mobile"
                                v-if="tournament.players_total > 0 && !tournament.event_is_corporate"
                            >
                                <p>Registered Players</p>

                                <p>{{ tournament.players_total }}</p>
                                <router-link
                                    :to="{
                                        name: 'ParticipantsList',
                                        params: { id: tournament.event_uuid },
                                    }"
                                >
                                    <img src="@/assets/people.svg" alt="" />
                                </router-link>
                                <!--  <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><g><g/><g><g><path d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3 C23,14.82,19.43,13.53,16.67,13.13z" fill-rule="evenodd"/></g><g><circle cx="9" cy="8" fill-rule="evenodd" r="4"/></g><g><path d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z" fill-rule="evenodd"/></g><g><path d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z" fill-rule="evenodd"/></g></g></g></svg>-->
                            </div>
                        </div>
                        <div>
                            <img
                                v-if="!registration"
                                class="pic-event-desktop"
                                src="../../assets/Tournament/ilustration.svg"
                                alt="chess illustration"
                            />

                            <div v-else-if="loaded" style="flex-direction: column">
                                <div class="flexend">
                                    <div
                                        style="padding-right: 0"
                                        v-if="
                                            (!tournament.event_is_corporate ||
                                                tournament.event_uuid !== 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b') &&
                                            !registerForm &&
                                            !registerFormCompany &&
                                            !nextPage &&
                                            tournament.registration &&
                                            registerOk &&
                                            new Date(tournament.event_date_to) >= new Date() - 86400000
                                        "
                                        class="confirm-button2-cream flex-center"
                                        @click="register()"
                                    >
                                        <p>Register</p>
                                    </div>
                                    <router-link
                                        v-if="tournament.players_total > 0"
                                        :to="{
                                            name: 'ParticipantsList',
                                            params: { id: tournament.event_uuid },
                                        }"
                                    >
                                        <div
                                            v-if="!registerForm && !registerFormCompany && !registerOk"
                                            class="confirm-button2 flex-center"
                                            style="padding-right: 0px"
                                        >
                                            <p>Participants</p>
                                        </div>
                                        <div
                                            v-else-if="
                                                !registerForm &&
                                                !registerFormCompany &&
                                                registerOk &&
                                                (!tournament.event_is_corporate ||
                                                    tournament.event_uuid !== 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b')
                                            "
                                            class="confirm-button2 flex-center"
                                            style="padding-right: 0px"
                                        >
                                            <p>Participants</p>
                                        </div>
                                        <div
                                            v-else-if="checkSA"
                                            class="confirm-button2 flex-center"
                                            style="padding-right: 0px"
                                        >
                                            <p>Participants</p>
                                        </div>
                                    </router-link>
                                </div>
                                <div
                                    class="players-registred desktop"
                                    v-if="tournament.players_total > 0 && !tournament.event_is_corporate"
                                >
                                    <p>Registered Players</p>

                                    <p>{{ tournament.players_total }}</p>
                                    <router-link
                                        :to="{
                                            name: 'ParticipantsList',
                                            params: { id: tournament.event_uuid },
                                        }"
                                    >
                                        <img src="@/assets/people.svg" alt="" />
                                    </router-link>
                                </div>
                            </div>

                            <img
                                v-if="tournament.event_image"
                                class="image-event pic-event-mobile"
                                :src="tournament.event_image"
                                alt="chess illustration"
                            />
                            <img
                                v-else
                                class="pic-event-mobile"
                                src="../../assets/Tournament/ilustration.svg"
                                alt="chess illustration"
                            />
                        </div>
                    </div>

                    <div
                        class="main-row"
                        :class="{ 'main-row2': registerForm && !registerFormCompany, 'main-row-info': billInfoView }"
                    >
                        <div v-if="nextPage" class="left">
                            <div class="left-paypal">
                                <div v-if="!orderCompleted">
                                    <p>
                                        To finish registration, please proceed to pay
                                        <span
                                            >{{ currency }}{{ (choosenFee + choosenFeeAccommodation).toFixed(2) }}
                                        </span>
                                        for participation fee.
                                    </p>

                                    <!-- <p>Pay by card or via PayPal:</p> -->
                                </div>
                                <div v-if="orderCompleted">
                                    <p>You have successfully entered the tournament. Good luck at the event!</p>
                                </div>
                                <!-- <div >
                                    <MonriPayment
                                        :choosenFee="choosenFee"
                                        :email="email"
                                        :tournament="tournament"
                                        :name_first="name_first"
                                        :name_last="name_last"
                                        :event_uuid="tournament.event_uuid"
                                        :nick="nick"
                                        :checkboxFide="this.checkbox"
                                        :player_gender_paypal="this.player_gender"
                                        :rating_paypal="this.rating"
                                        :rating_b_paypal="this.rating_b"
                                        :rating_r_paypal="this.rating_r"
                                        :title_uuid_paypal="this.title_uuid"
                                    />
                                </div> -->
                                <!-- kgukjsgd -->
                                <div v-if="!noWallet"></div>
                                <div
                                    v-if="!noWallet && !choosenFeeAccommodation"
                                    class="monri-button brown"
                                    @click="openDivWallet = !openDivWallet"
                                >
                                    Pay with Outpost wallet
                                </div>
                                <div v-if="openDivWallet" class="wallet-pay-div">
                                    <div>
                                        <p>
                                            The Available amount in the wallet:
                                            <span> {{ currency }}{{ this.walletSum.total.toFixed(2) }} </span>
                                        </p>
                                        <p>
                                            Pay
                                            <span>
                                                {{ currency
                                                }}{{ (choosenFee + choosenFeeAccommodation).toFixed(2) }}</span
                                            >
                                            from wallet?
                                        </p>
                                        <div class="buttons-confirm-wallet">
                                            <div @click="payByWallet" class="confirm-button2">Yes</div>
                                            <div @click="openDivWallet = false" class="confirm-button2">No</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="monri-button" @click="monriCardPayment = !monriCardPayment">
                                    Pay by Credit or Debit card
                                </div>
                                <div v-show="monriCardPayment">
                                    <MonriPaymentComp
                                        :choosenFee="choosenFee"
                                        :choosenFeeAccommodation="choosenFeeAccommodation"
                                        :email="email"
                                        :tournament="tournament"
                                        :name_first="name_first"
                                        :name_last="name_last"
                                        :event_uuid="tournament.event_uuid"
                                        :nick="nick"
                                        :checkboxFide="this.checkbox"
                                        :player_gender_paypal="this.player_gender"
                                        :rating_paypal="this.rating"
                                        :rating_b_paypal="this.rating_b"
                                        :rating_r_paypal="this.rating_r"
                                        :title_uuid_paypal="this.title_uuid"
                                        :user="user"
                                        :fide_id="fide_id"
                                        :currency="tournament.price_currency"
                                        @openTerms="openTerms"
                                    />
                                </div>
                                <div
                                    class="bill-button"
                                    v-if="
                                        payCompanyBill &&
                                        !billInfoView &&
                                        tournament.event_uuid == 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b'
                                    "
                                    @click="billInfoView = !billInfoView"
                                >
                                    <!-- request-bill -->
                                    Request a bank transfer
                                </div>

                                <div
                                    class="request-bill"
                                    v-if="
                                        billInfoView && tournament.event_uuid == 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b'
                                    "
                                >
                                    <div>
                                        <img
                                            @click="billInfoView = !billInfoView"
                                            src="../../assets/arrow-back.svg"
                                            alt="back icon"
                                        />
                                    </div>

                                    Please contact FIDE to get the payment information:
                                    <span class="color-brown">worldcorporate@fide.com</span>
                                </div>
                                <div
                                    class="billing-info"
                                    v-if="
                                        billInfoView && tournament.event_uuid == 'e4a8fd32-d24d-11ee-aa36-66d6ee15200b'
                                    "
                                >
                                    <!-- <p class="billing-info-text">
                                        Please contact FIDE  <span class="color-brown">worldcorporate@fide.com</span>
                                    </p> -->
                                    <!-- <p class="billing-info-text color-brown">worldcorporate@fide.com</p> -->

                                    <div class="bill-button bill-button2" @click="registerWithoutPayment">
                                        Proceed to the participant list
                                    </div>
                                    <!-- <p style="font-size: 12px">*Please inform organizer after the payment</p> -->
                                </div>
                                <div v-show="company_data == ''">
                                    <div :class="{ 'opacity-paypal': monriCardPayment }" id="paypal-button-container" />
                                </div>

                                <div
                                    v-if="!orderCompleted"
                                    class="confirm-button2 absolute flex-center"
                                    style="cursor: pointer; border: 0.5px solid rgba(92, 94, 100, 1)"
                                    @click="nextPage = false"
                                >
                                    Back
                                </div>
                                <router-link
                                    :to="{
                                        name: 'ParticipantsList',
                                        params: { id: tournament.event_uuid },
                                    }"
                                >
                                    <div v-if="orderCompleted" class="confirm-button2 absolute flex-center">Done</div>
                                </router-link>
                            </div>
                        </div>

                        <div v-else-if="!registerForm && !registerFormCompany" class="left">
                            <div class="block block-location">
                                <div class="cont no-edit">
                                    <img
                                        style="position: relative; left: -3px; height: 20px"
                                        src="../../assets/Tournament/location-icon.svg"
                                        alt=""
                                    />
                                    <p style="position: relative; left: -5px" class="cont-header">LOCATION</p>
                                    <div style="display: flex; flex-wrap: wrap">
                                        <p
                                            style="width: max-content"
                                            v-if="!tournament.event_is_online && tournament.event_city"
                                        >
                                            {{ tournament.event_city }},
                                        </p>

                                        <p
                                            v-if="
                                                tournament.country_details &&
                                                tournament.country_details.name !== 'Other' &&
                                                !tournament.event_is_online
                                            "
                                        >
                                            {{ tournament.country_details.name }}
                                        </p>
                                    </div>
                                    <p v-if="tournament.event_is_online == true">
                                        Online, {{ tournament.online_place }}
                                    </p>
                                </div>
                            </div>
                            <div class="block block-start">
                                <div class="cont no-edit">
                                    <img src="../../assets/Tournament/time-start.svg" alt="" />
                                    <p class="cont-header">START</p>
                                    <p
                                        v-if="tournament.event_timezone == null && tournament.event_date_from !== null"
                                        class="date-start"
                                    >
                                        {{ tournament.event_date_from.slice(-2) }}
                                        {{ months[new Date(tournament.event_date_from).getMonth()] }}
                                        {{ new Date(tournament.event_date_from).getFullYear() }}
                                    </p>
                                    <p class="date-start">
                                        {{ dateTour }}
                                        {{ months[monthTour * 1 - 1] }}
                                        {{ yearTour }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="tournament.event_date_from !== tournament.event_date_to" class="block block-end">
                                <div class="cont no-edit">
                                    <img src="../../assets/Tournament/time-end.svg" alt="" />
                                    <p class="cont-header">END</p>
                                    <p v-if="tournament.event_date_to !== null" class="date-end">
                                        {{ tournament.event_date_to.slice(-2) }}
                                        {{ months[new Date(tournament.event_date_to).getMonth()] }}
                                        {{ new Date(tournament.event_date_to).getFullYear() }}
                                    </p>
                                </div>
                            </div>
                            <div
                                v-if="tournament.event_start_hour !== null && tournament.event_start_minute !== null"
                                class="block block-end"
                            >
                                <div class="cont no-edit">
                                    <img src="../../assets/Tournament/time-end.svg" alt="" />
                                    <p class="cont-header">TIME</p>
                                    <p v-if="diffCount" class="date-end">{{ hourTour }}:{{ minuteTour }}</p>
                                    <p v-if="!diffCount" class="date-end">{{ hours }}:{{ minutes }} &nbsp;&nbsp;</p>
                                    <p v-if="!diffCount" style="font-size: 14px; color: #6f7381">
                                        ( {{ tournament.event_timezone }} )
                                    </p>
                                </div>
                            </div>
                            <div class="block block-control">
                                <div class="cont no-edit cont-time-control">
                                    <div>
                                        <img src="../../assets/Tournament/time-control.svg" alt="" />
                                        <p class="cont-header">TIME CONTROL TYPE</p>
                                    </div>
                                    <div>
                                        <div v-if="tournament.event_time_control_type" class="btn no-edit">
                                            <img src="../../assets/Tournament/check.svg" alt="" />
                                            <p style="font-size: 14px; font-weight: 600; color: white">
                                                {{ tournament.event_time_control_type === "s" ? "Standard" : "" }}
                                                {{ tournament.event_time_control_type === "r" ? "Rapid" : "" }}
                                                {{ tournament.event_time_control_type === "b" ? "Blitz" : "" }}
                                            </p>
                                            <img src="../../assets/Tournament/qr-code.svg" alt="" />
                                        </div>
                                        <p>{{ tournament.event_time_control_desc }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="tournament.regulation_file_url" class="block">
                                <div class="cont">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="16px"
                                        viewBox="0 0 24 24"
                                        width="16px"
                                        fill="rgb(200, 160, 125,0.7)"
                                    >
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <path
                                            d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
                                        />
                                    </svg>

                                    <p class="cont-header color-brown">REGULATION FILE</p>
                                    <a
                                        v-if="
                                            tournament.event_uuid == 'aaeccc84-eb8b-11ee-9c6d-96a56a2cc0a7' ||
                                            !tournament.regulation_file_url.startsWith('http')
                                        "
                                        style="max-width: 120px; z-index: 50"
                                        :href="'https://' + tournament.regulation_file_url"
                                        target="_blank"
                                    >
                                        <div class="btn-file no-edit">
                                            <p style="font-size: 14px">Open File</p>
                                            <!--   <img src="../../assets/Tournament/qr-code.svg" alt="" />-->
                                        </div>
                                    </a>
                                    <a
                                        v-else
                                        style="max-width: 120px; z-index: 50"
                                        :href="tournament.regulation_file_url"
                                        target="_blank"
                                    >
                                        <div class="btn-file no-edit">
                                            <p style="font-size: 14px">Open File</p>
                                            <!--   <img src="../../assets/Tournament/qr-code.svg" alt="" />-->
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div v-if="tournament.online_club" class="block">
                                <div class="cont web">
                                    <img src="../../assets/Tournament/website-icon.svg" alt="" />

                                    <a
                                        v-if="
                                            tournament.online_club && tournament.online_club.substring(0, 3) !== 'htt'
                                        "
                                        :href="'//' + tournament.online_club"
                                        target="_blank"
                                        >{{ tournament.online_club }}</a
                                    >

                                    <a v-else :href="tournament.online_club" target="_blank">{{
                                        tournament.online_club
                                    }}</a>
                                </div>
                            </div>
                            <div class="block block-website">
                                <div class="cont no-border web">
                                    <img src="../../assets/Tournament/website-icon.svg" alt="" />

                                    <a
                                        v-if="tournament.event_url && tournament.event_url.substring(0, 3) !== 'htt'"
                                        :href="'//' + tournament.event_url"
                                        target="_blank"
                                        >{{ tournament.event_url }}</a
                                    >

                                    <a v-else :href="tournament.event_url" target="_blank">{{
                                        tournament.event_url
                                    }}</a>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="registerForm && !registerFormCompany" class="left">
                            <div
                                class="block block-location block-with-border"
                                :class="{ 'block-border-top': registerForm }"
                            >
                                <div class="cont">
                                    <p
                                        v-if="!logedIn"
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm, colored2: colored }"
                                    >
                                        FIDE
                                    </p>
                                    <p
                                        v-else-if="uscf_bool == false"
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm, colored2: colored }"
                                    >
                                        FIDE ID
                                    </p>
                                    <p
                                        v-else
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm, colored2: colored }"
                                    >
                                        FIDE ID
                                    </p>
                                    <p
                                        v-if="
                                            logedIn &&
                                            colored &&
                                            (user.fide_id == null || user.fide_id == '') &&
                                            checkbox == false
                                        "
                                        class="colored no-border"
                                    >
                                        !
                                    </p>
                                    <p
                                        v-if="!logedIn && colored && fide_id == '' && checkbox == false"
                                        class="colored no-border"
                                    >
                                        !
                                    </p>
                                    <!--      <input
                                        v-if="logedIn && user.fide_id !== null && user.fide_id !== ''"
                                        class="input-registration no-edit"
                                        :class="{ 'input-line-throuhgh': checkbox }"
                                        readonly
                                        v-model="user.fide_id"
                                    />  -->
                                    <div v-if="logedIn" style="display: flex">
                                        <input
                                            v-model="fide_id"
                                            class="input-registration check-first"
                                            :class="{ 'input-line-throuhgh': checkbox }"
                                            :readonly="checkbox"
                                            type="number"
                                            placeholder="Enter ID"
                                        />
                                        <div
                                            v-if="
                                                fide_id == null ||
                                                fide_id == '' ||
                                                fide_id == undefined ||
                                                fide_id == '/'
                                            "
                                            class="check-first checkboxFide"
                                        >
                                            <v-app id="inspire">
                                                <v-checkbox v-model="checkbox" label="No ID" />
                                            </v-app>
                                        </div>
                                        <div v-if="dubbleFideId">
                                            <p class="not_exist_message">
                                                Player with entered FIDE ID is already on list
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else style="display: flex">
                                        <input
                                            v-model="fide_id"
                                            class="input-registration"
                                            :class="{ 'input-line-throuhgh': checkbox }"
                                            type="number"
                                            :readonly="checkbox"
                                            placeholder="Enter ID"
                                        />
                                        <div v-if="fide_id == ''" class="checkboxFide check-first">
                                            <v-app id="inspire">
                                                <v-checkbox v-model="checkbox" label="No ID" />
                                            </v-app>
                                        </div>
                                        <Transition name="fade" mode="out-in">
                                            <div class="div-country" v-if="fide_id !== ''">
                                                <div
                                                    class="flex-center online-button online-button-hover"
                                                    @click="fideFill"
                                                >
                                                    <p>Generate data</p>
                                                </div>
                                                <div class="no-exist-div" v-if="notExist">
                                                    <p class="not_exist_message">*Requested player does not exist</p>
                                                </div>
                                                <div v-if="dubbleFideId" class="no-exist-div2">
                                                    <p class="not_exist_message">
                                                        Player with entered FIDE ID is already on list
                                                    </p>
                                                </div>
                                            </div>
                                        </Transition>
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm }"
                                    >
                                        NAME
                                    </p>
                                    <p
                                        v-if="colored && (name_first == '' || name_first == undefined)"
                                        class="colored no-border"
                                    >
                                        !
                                    </p>

                                    <input
                                        v-if="logedIn && !playerIsFide"
                                        v-model="user.name_first"
                                        class="input-registration"
                                        :class="{ 'no-edit': user.name_first }"
                                        type="text"
                                        placeholder="Enter name"
                                        :readonly="user.name_first"
                                    />
                                    <input
                                        v-else
                                        :readonly="(inactiveFields && !checkbox) || playerIsFide"
                                        v-model="name_first"
                                        class="input-registration"
                                        type="text"
                                        placeholder="Enter name"
                                    />
                                </div>
                            </div>
                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm }"
                                    >
                                        LAST NAME
                                    </p>
                                    <p
                                        v-if="colored && (name_last == '' || name_last == undefined)"
                                        class="colored no-border"
                                    >
                                        !
                                    </p>
                                    <input
                                        v-if="logedIn && !playerIsFide"
                                        v-model="user.name_last"
                                        class="input-registration"
                                        :class="{ 'no-edit': user.name_last }"
                                        type="text"
                                        placeholder="Enter last name"
                                        :readonly="user.name_last"
                                    />
                                    <input
                                        v-else
                                        :readonly="(inactiveFields && !checkbox) || playerIsFide"
                                        v-model="name_last"
                                        class="input-registration"
                                        type="text"
                                        placeholder="Enter last name"
                                    />
                                </div>
                            </div>

                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p class="row-first">GENDER</p>
                                    <p
                                        v-if="colored && male == false && female == false"
                                        class="colored no-border margin-gender"
                                    >
                                        !
                                    </p>
                                    <div style="margin-left: 15px">
                                        <div v-if="user.sex == null" class="checkboxFide">
                                            <v-app id="inspire">
                                                <v-checkbox
                                                    :readonly="(inactiveFields && !checkbox) || playerIsFide"
                                                    v-model="male"
                                                    label="Male"
                                                    @click="maleClick"
                                                />
                                            </v-app>
                                            <v-app id="inspire">
                                                <v-checkbox
                                                    :readonly="(inactiveFields && !checkbox) || playerIsFide"
                                                    v-model="female"
                                                    label="Female"
                                                    @click="femaleClick"
                                                />
                                            </v-app>
                                        </div>
                                        <div v-else class="checkboxFide">
                                            <v-app id="inspire">
                                                <v-checkbox v-model="male" readonly label="Male" />
                                            </v-app>
                                            <v-app id="inspire">
                                                <v-checkbox v-model="female" readonly label="Female" />
                                            </v-app>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="{ opacity7: inactiveFields && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p class="row-first">RATING</p>
                                    <input
                                        v-if="!user.rating_standard || playerIsFide"
                                        :readonly="inactiveFields || playerIsFide"
                                        v-model="rating"
                                        class="input-registration"
                                        type="number"
                                        placeholder="Enter standard rating"
                                    />
                                    <input
                                        v-else
                                        :readonly="playerIsFide"
                                        v-model="user.rating_standard"
                                        class="input-registration"
                                        type="number"
                                    />
                                </div>
                            </div>
                            <div
                                :class="{ opacity7: inactiveFields && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p class="row-first">TITLE</p>

                                    <input
                                        v-if="!user.titula_player || playerIsFide"
                                        :readonly="inactiveFields || playerIsFide"
                                        v-model="title"
                                        class="input-registration"
                                        type="text"
                                        placeholder="Enter title"
                                    />
                                    <input
                                        v-else
                                        v-model="user.titula_player_details.titula_short_name"
                                        class="input-registration"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont cont-relative">
                                    <p
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm }"
                                    >
                                        EMAIL
                                    </p>
                                    <p v-if="(colored && email == '') || errorMail" class="colored no-border">!</p>
                                    <input
                                        v-if="logedIn"
                                        v-model="user.email"
                                        class="input-registration"
                                        type="email"
                                        :class="{ 'no-edit': user.email }"
                                        placeholder="Enter e-mail address"
                                        :readonly="user.email"
                                    />
                                    <input
                                        v-else
                                        :readonly="inactiveFields && !checkbox"
                                        v-model="email"
                                        class="input-registration"
                                        type="email"
                                        placeholder="Enter e-mail address"
                                    />
                                    <div v-if="dubbleMail" class="cont-absolute-row">
                                        <p>This email is already registred for this event</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="!logedIn"
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p class="row-first">PHONE</p>

                                    <input
                                        v-model="player_phone"
                                        class="input-registration"
                                        type="number"
                                        placeholder="Enter number (*optional)"
                                    />
                                </div>
                            </div>
                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                v-if="tournament.price[0] && tournament.registration"
                                class="block block-location block-with-border"
                            >
                                <div class="cont" style="justify-content: space-between">
                                    <p
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm }"
                                    >
                                        ENTRY FEE
                                    </p>

                                    <div style="position: relative">
                                        <div
                                            style="margin-left: 15px; margin-right: 29px"
                                            class="fee-dropdown"
                                            :class="{
                                                'fee-dropdown2': entryFees,
                                                colored: this.colored && this.choosenFee == '',
                                            }"
                                            @click="openDrop"
                                        >
                                            <p v-if="choosenFee == '' && choosenFee !== 0">Choose fee</p>
                                            <p v-else style="color: #ceceda !important">
                                                {{ textEntreyFee }}
                                            </p>
                                            <img src="@/assets/event/drop-arrow.svg" alt="arrow" />
                                        </div>
                                        <div v-if="entryFees">
                                            <div
                                                style="max-width: 300px"
                                                :readonly="inactiveFields && !checkbox"
                                                class="dropdown"
                                            >
                                                <div
                                                    v-for="fee in tournament.price"
                                                    :key="fee.name"
                                                    class="drop_fee"
                                                    @click="feeSelection(fee)"
                                                >
                                                    {{ fee.price_name }} - {{ currency }}{{ fee.price_amount }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                v-if="tournament.accommodation_price && tournament.registration"
                                class="block block-location block-with-border"
                            >
                                <div
                                    v-if="tournament.accommodation_price[0]"
                                    class="cont"
                                    style="justify-content: space-between"
                                >
                                    <p
                                        style="line-height: 36px"
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm }"
                                    >
                                        ACCOMMODATION FEE
                                    </p>

                                    <div style="position: relative">
                                        <div
                                            style="margin-left: 15px; margin-right: 29px"
                                            class="fee-dropdown"
                                            :class="{
                                                'fee-dropdown2': chooseAcc,
                                                hide: entryFees && tournament.accommodation_price.length > 0,
                                            }"
                                            @click="openDropAcc"
                                        >
                                            <!-- colored: this.colored && this.choosenFeeAccommodation == '', -->
                                            <p v-if="choosenFeeAccommodation == '' && choosenFeeAccommodation !== 0">
                                                Choose fee
                                            </p>
                                            <p v-else style="color: #ceceda !important">
                                                {{ textEntreyAccFee }}
                                            </p>
                                            <img src="@/assets/event/drop-arrow.svg" alt="arrow" />
                                        </div>
                                        <div v-if="chooseAcc">
                                            <div
                                                style="max-width: 300px"
                                                :readonly="inactiveFields && !checkbox"
                                                class="dropdown"
                                            >
                                                <div
                                                    v-for="fee in tournament.accommodation_price"
                                                    :key="fee.name"
                                                    class="drop_fee"
                                                    @click="feeAccommodationSelection(fee)"
                                                >
                                                    {{ fee.price_name }} - {{ currency }}{{ fee.price_amount }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                :class="{ opacity7: inactiveFields && !checkbox && !logedIn }"
                                v-if="tournament.event_is_online == true"
                                class="block block-location block-with-border"
                            >
                                <div class="cont">
                                    <p
                                        class="row-first no-edit cont-header"
                                        :class="{ 'cont-header-reg': registerForm }"
                                    >
                                        NICK {{ tournament.online_place }}
                                    </p>
                                    <p v-if="colored && nick == ''" class="colored no-border">!</p>
                                    <input
                                        v-model="nick"
                                        :readonly="inactiveFields && !checkbox && !logedIn"
                                        class="input-registration"
                                        type="text"
                                        placeholder="Enter nickname"
                                    />
                                </div>
                            </div>
                            <div class="block block-location block-with-border">
                                <div v-if="!loader" class="cont no-border">
                                    <div class="flexend3">
                                        <div
                                            v-if="!tournament.price[0]"
                                            class="confirm-button2 flex-center"
                                            @click="registrationGo"
                                        >
                                            <p>Submit</p>
                                        </div>
                                        <div
                                            v-else
                                            class="confirm-button2 confirm-button2-brown flex-center"
                                            @click="next"
                                        >
                                            <p>Next</p>
                                        </div>
                                        <div class="button2 flex-center" @click="registrationCancel">
                                            <p>Cancel</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loader" v-else>
                                    <img src="@/assets/Precomp2.gif" alt="" />
                                </div>
                            </div>
                        </div>
                        <div v-else-if="registerFormCompany" class="left">
                            <TeamRegistration
                                @cancelRegister="cancelRegister"
                                @registerWithoutPayment="registerWithoutPayment"
                                @goToTeamPayment="goToTeamPayment"
                                :user="user"
                                :tournament="tournament"
                                :currency="currency"
                            />
                        </div>

                        <div v-if="!nextPage" class="right" :class="{ 'block-border-top': registerForm }">
                            <div>
                                <img
                                    v-if="tournament.event_image && tournament.event_image.startsWith('fra1')"
                                    class="tour-img"
                                    :src="
                                        `https://api.outpostchess.com/upload/w_400,ao_1/https://` +
                                        tournament.event_image
                                    "
                                    alt=""
                                />
                                <img
                                    v-else-if="tournament.event_image && !tournament.event_image.startsWith('fra1')"
                                    class="tour-img"
                                    :src="tournament.event_image"
                                    alt=""
                                />
                                <img
                                    v-if="!tournament.event_image"
                                    class="tour-placeholder"
                                    src="../../assets/Tournament/ilustration.svg"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div v-else class="right right-payment" :class="{ 'right-payment-terms': termsPopup }">
                            <div class="bottom-border-payment">
                                <p style="margin-left: 3px" class="color-gray" @click="openTerms">
                                    Terms and Conditions
                                </p>
                                <!-- <p @click="openSecurity">Security</p>
                                <p @click="openReturnPolicy">Return Policy</p>
                                <p @click="openPrivacy">Privacy Policy</p> -->
                            </div>

                            <div>
                                <!-- <div class="popup-cont" v-if="securityPopup">
                                    <svg
                                        class="svg-back"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 17 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        @click="closePolicy"
                                    >
                                        <g clip-path="url(#clip0_160_8100)">
                                            <path
                                                d="M10.7253 6.57485L10.2348 6.08469L8.2905 8.02796L6.34615 6.08469L5.85571 6.57485L7.80006 8.51813L5.85571 10.4614L6.34615 10.9516L8.2905 9.00829L10.2348 10.9516L10.7253 10.4614L8.78093 8.51813L10.7253 6.57485Z"
                                                fill="#11C6D1"
                                            />
                                        </g>
                                        <path
                                            d="M15.7904 8.52001C15.7904 12.6595 12.4328 16.0156 8.29041 16.0156C4.14801 16.0156 0.790405 12.6595 0.790405 8.52001C0.790405 4.38057 4.14801 1.02441 8.29041 1.02441C12.4328 1.02441 15.7904 4.38057 15.7904 8.52001Z"
                                            stroke="#11C6D1"
                                        />
                                        <defs>
                                            <clipPath id="clip0_160_8100">
                                                <rect
                                                    width="8.34783"
                                                    height="8.34323"
                                                    fill="white"
                                                    transform="translate(4.11658 4.34653)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    
                                    <h3>Return Policy</h3>
                                <p>
                                    WebPay service is not in any connection with purchased goods or services. We only
                                    authorize credit cards. If you have any question about your purchased goods or
                                    services please contact Merchant.
                                </p>
                                <p>
                                    If you have question about Your credit card charge please contact Merchant or Your
                                    credit card issuer. We thank You for choosing WebPay service, our secure product for
                                    online credit card processing.
                                </p>
                                </div> -->
                            </div>

                            <div class="popup-cont" v-if="termsPopup">
                                <svg
                                    class="svg-back"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    @click="closePolicy"
                                >
                                    <g clip-path="url(#clip0_160_8100)">
                                        <path
                                            d="M10.7253 6.57485L10.2348 6.08469L8.2905 8.02796L6.34615 6.08469L5.85571 6.57485L7.80006 8.51813L5.85571 10.4614L6.34615 10.9516L8.2905 9.00829L10.2348 10.9516L10.7253 10.4614L8.78093 8.51813L10.7253 6.57485Z"
                                            fill="#11C6D1"
                                        />
                                    </g>
                                    <path
                                        d="M15.7904 8.52001C15.7904 12.6595 12.4328 16.0156 8.29041 16.0156C4.14801 16.0156 0.790405 12.6595 0.790405 8.52001C0.790405 4.38057 4.14801 1.02441 8.29041 1.02441C12.4328 1.02441 15.7904 4.38057 15.7904 8.52001Z"
                                        stroke="#11C6D1"
                                    />
                                    <defs>
                                        <clipPath id="clip0_160_8100">
                                            <rect
                                                width="8.34783"
                                                height="8.34323"
                                                fill="white"
                                                transform="translate(4.11658 4.34653)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <h3>Privacy protection</h3>
                                <p>
                                    OutpostChess doo obligates to protect everyone's privacy. We only collect necessary,
                                    basic data about customers/users and data necessary for business and user
                                    information in accordance with good business practices customs and in order to
                                    provide quality service. We give customers a choice including the ability to decide
                                    whether or not they want to be removed from mailing lists used for marketing
                                    purposes campaigns. All user/customer data is strictly kept and is only available to
                                    employees for which these data are necessary for the performance of work. All
                                    employees of Outpost Chess (and business partners) are responsible for respecting
                                    the principles of privacy protection.
                                </p>
                                <h3>Protection of confidential transaction data</h3>

                                <p>
                                    When entering payment card data, confidential information is transmitted via public
                                    network in a protected (encrypted) form using SSL protocol and PKI system, as
                                    currently state-of-the-art cryptographic technologies. Data security during
                                    purchases is guaranteed by the payment card processor, Banca Intesa ad Belgrade, so
                                    the complete billing process is done on the bank's website. Payment card information
                                    is not available to our system.
                                </p>

                                <h3>Ordering</h3>
                                <p>
                                    The customer orders the product or products via the electronic order form. Any
                                    person who electronically orders at least one product, fills in the required
                                    information and sends it is considered a customer the order. Services are considered
                                    ordered when the customer chooses and confirms the payment method.
                                </p>

                                <p>
                                    During the purchase process, a document/confirmation is sent to the customer by
                                    email, which confirms the purchase of the service.
                                </p>

                                <h3>Complaints</h3>
                                <p>
                                    Complaints are not common and can be initiated in case of misuse of the card,
                                    possibly due to force majeure. Please contact us by email and we will resolve your
                                    complaint in direct communication as soon as possible.
                                </p>

                                <h3>Refund</h3>
                                <p>
                                    In the case of a return of goods and the need for a refund to a customer who had
                                    made a payment using one of the accepted payment cards, whether in part or in full,
                                    regardless of the reason for the return, Outpost Chess is obligated to process the
                                    refund exclusively through VISA, EC/MC, Maestro, Amex, and Dina payment methods.
                                    This means that, upon request, the bank will instruct the seller to refund the funds
                                    to the cardholder's account.
                                </p>

                                <h3>Company info and contact</h3>

                                <p>
                                    Outpost Chess DOO<br />
                                    Address: Veljka Dugosevica, Belgrade<br />
                                    MB: 21683582 <br />
                                    PIB/VAT: 112480188 <br />
                                    Activity Code: 6202 <br />
                                    Email: info@outpostchess.com<br />
                                    Phone: +381645333308
                                </p>

                                <p>Outpost Chess doo is not in the VAT system.</p>
                            </div>

                            <div class="order-info color-white2">
                                <div style="justify-content: flex-start">
                                    <p>
                                        Item cart for <span>{{ tournament.event_name }}</span>
                                    </p>
                                </div>
                                <div class="bottom-border-payment-total" v-if="!orderCompleted">
                                    <div v-if="choosenFee !== '' && choosenFeeAccommodation !== ''">
                                        <p>• Registration event fee <br />{{ choosenFeeName }}</p>
                                        <p>
                                            <span>{{ currency }}{{ choosenFee.toFixed(2) }}</span>
                                        </p>
                                    </div>
                                    <div
                                        v-if="
                                            choosenFee !== '' &&
                                            choosenFeeAccommodation !== '' &&
                                            choosenFeeAccommodation !== 0
                                        "
                                    >
                                        <p>
                                            • Accommodation fee <br />
                                            {{ choosenFeeAccommodationName }}
                                        </p>
                                        <p>
                                            <span>{{ currency }}{{ choosenFeeAccommodation.toFixed(2) }}</span>
                                        </p>
                                    </div>

                                    <!-- <p>Pay by card or via PayPal:</p> -->
                                </div>
                                <div class="payment-total" v-if="!orderCompleted">
                                    <p>Total</p>
                                    <p>
                                        <span
                                            >{{ currency }}{{ (choosenFee + choosenFeeAccommodation).toFixed(2) }}</span
                                        >
                                    </p>
                                </div>
                            </div>
                            <!-- <div class="color-gray contact-info">
                                <p>Contact Info:</p>
                                <p>Outpost Chess DOO</p>
                                <p>Address: Veljka Dugosevica, Belgrade</p>
                                <p>Email: info@outpostchess.com</p>
                                <p>Phone: +381645333308</p>
                            </div> -->
                        </div>
                    </div>

                    <div v-if="tournament.price">
                        <div v-if="tournament.registration && tournament.price.length > 0" class="all-logos">
                            <div class="logotips-payment">
                                <a href="https://www.mastercard.com"
                                    ><img style="height: 38px" src="@/assets/monri/mc.svg" alt="mastercard"
                                /></a>
                                <a><img style="height: 38px" src="@/assets/monri/maestro.svg" alt="mastercard" /></a>
                                <a href="https://www.visaeurope.com"
                                    ><img src="@/assets/monri/Visa_Brandmark_Blue_Black.png" alt="visa"
                                /></a>
                                <a>
                                    <img src="@/assets/monri/DinaCard.png" alt="dina" />
                                </a>
                            </div>
                            <div class="logotips-payment">
                                <a href="https://www.bancaintesa.rs/"
                                    ><img src="@/assets/monri/banca intesa_color.png" alt="intesa"
                                /></a>
                                <a
                                    href="https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html"
                                    ><img src="@/assets/monri/visa-secure.jpg" alt="visa-secure"
                                /></a>
                                <a href=" http://www.mastercard.com/rs/consumer/credit-cards.html"
                                    ><img src="@/assets/monri/mc_idcheck.svg" alt="mc-secure"
                                /></a>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="!registerForm && !registerFormCompany && tournament.event_description"
                        class="tournament-desc no-edit"
                    >
                        <p style="white-space: pre-line" v-html="markdownContent" />
                    </div>
                </div>
            </div>

            <div id="checkClick" class="wallet-notificatio">
                <Notifications />
            </div>
        </div>
        <div class="footer_mobile">
            <ChatroomFooter />
        </div>
    </div>
</template>

<script>
import DOMPurify from "dompurify";
import { marked } from "marked";

import Notifications from "@/components/Notification/Notifications";
import SideBar from "@/components/SideBar";
import ChatroomFooter from "@/components/Chatroom/ChatroomFooter";
import MobileHeader from "@/components/MobileHeader";
//import MonriPayment from "@/components/Monri/MonriPayment";
import MonriPaymentComp from "@/components/Monri/MonriPaymentComp";
import ShareTournament from "@/components/Tournament/ShareTournament";

export default {
    name: "TournamentInner",
    components: {
        Notifications,
        SideBar,
        ChatroomFooter,
        MobileHeader,
        //  MonriPayment,
        MonriPaymentComp,
        ShareTournament,
        TeamRegistration: () => import("@/components/Tournament/TeamRegistration.vue"),
    },
    props: ["event_uuid"],
    data() {
        return {
            shadow: false,
            isSidebarOpen: false,
            tournament: Object,
            months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            userId: null,
            user: {},
            notLoged: false,
            registration: true,
            registerForm: false,
            nick: "",
            colored: false,
            logedIn: false,
            name_last: "",
            name_first: "",
            email: "",
            fide_id: "",
            organiser_evet_list: { player_email: "" },
            loaded: false,
            entryFees: false,
            nextPage: false,
            choosenFee: "",
            choosenFeeAccommodation: "",
            errorMail: false,
            dubbleMail: false,
            checkbox: false,
            orderCompleted: false,
            transaction: "",
            idt: "",
            paypalParams: { appid: "" },
            pageLoad: false,
            registredPlayer: {},
            registerOk: true,
            routControl: "",
            female: false,
            male: false,
            feeClicked: false,
            player_gender: "",
            hours: "",
            minutes: "",
            ampm: "",
            minuteDiff: "",
            hoursDiff: "",
            minuteDiff2: "",
            hourDiff2: "",
            yearTour: "",
            monthTour: "",
            dateTour: "",
            hourTour: "",
            minuteTour: "",
            afterhour: "",
            diffCount: false,
            dataToFormat2: "",
            uscf_bool: false,
            loader: false,
            user_fide: "",
            notExist: false,
            rating: 0,
            inactiveFields: true,
            rating_b: 0,
            rating_r: 0,
            title: "",
            title_uuid: String,
            title2: "",
            player_phone: "",
            invoice: [],
            invoice2: [],
            monriCardPayment: false,
            chooseAcc: false,
            dubbleFideId: false,
            textEntreyAccFee: "",
            textEntreyFee: "",
            purchase: [],
            loadTournament: false,
            //  securityPopup: false,
            termsPopup: false,
            // privacyPopup: false,
            choosenFeeAccommodationName: "",
            choosenFeeName: "",
            currency: "",
            playerIsFide: false,
            walletSum: "",
            noWallet: true,
            openDivWallet: false,
            responseWallet: [],
            registerFormCompany: false,
            company_data: "",
            payCompanyBill: false,
            billInfoView: false,
            event_id: "",
            fideWithoutPay: false,
            checkSA: false,
            checkMail: "",
            loadHeader: false,
        };
    },
    computed: {
        markdownContent() {
            return DOMPurify.sanitize(marked.parse(this.tournament.event_description));
        },
    },
    watch: {
        nextPage() {
            if (this.nextPage == true) {
                this.paypalActive();
            }
        },
        fide_id() {
            if (this.fide_id && this.tournament.registration == true) {
                if (this.fide_id.length > 5 && this.fide_id.length < 12 && this.logedIn) {
                    this.fideFill();
                }
            }
        },

        "$store.state.current_user"() {
            this.checkSex();
        },
    },
    mounted() {
        this.paypalActive();
        if (this.logedIn && this.$store.state.current_user) {
            if (
                localStorage.getItem("id") == "e0caf20e-5e6f-11ed-b904-7ee1ac15c117" ||
                localStorage.getItem("id") == "24d29ce8-1d14-11ec-a733-0d4e300cf032" ||
                localStorage.getItem("id") == "9f36ee32-20f5-11ec-a733-0d4e300cf032"
            ) {
                this.checkSA = true;
                // console.log(this.checkSA )
            }
        }
        if (localStorage.getItem("token")) {
            fetch(process.env.VUE_APP_URL + "/paypal_env_params_per_user", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())
                .then(data => (this.paypalParams = data));
            //  .then(data => console.log("paypalParams", data));
        } else {
            fetch(process.env.VUE_APP_URL + "/paypal_env_params_per_user", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => (this.paypalParams = data));
            //.then(data => console.log("paypal_env_params_per_user", data));
        }

        this.checkSex();
    },
    async created() {
        this.idt = this.$route.params.id;
        this.routControl = this.$route.query.routeFrom;
        this.event_id = window.location.href.split("/").pop();
        // console.log(this.event_id);
        // const eventId = this.$route.params.id;
        const baseUrl = process.env.VUE_APP_URL;
        this.logedIn = localStorage.getItem("token") ? true : false;
        ///console.log("provera", this.logedIn);
        try {
            const res = await fetch(`${baseUrl}/tournamentv2/${this.$route.params.id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const data = await res.json();
            // console.log("provera date", data);
            this.tournament = data;

            this.checkInnerOrg();

            // this.tournamentDesc = data.event_description;
        } catch (e) {
            console.error(e.message);
        }
        //   console.log(this.tournamentDesc);

        fetch(process.env.VUE_APP_URL + `organiser_event_players_v2/${this.$route.params.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => (this.organiser_evet_list = data))
            //.then(data => console.log("event_list", data))

            .then(this.load);

        if (localStorage.getItem("token")) {
            fetch(process.env.VUE_APP_URL + "/current_user_info", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())
                .then(data => (this.user = data))

                // .then(data => console.log("user", data))
                // this.userId = localStorage.getItem("id");
                .then(this.setData);
        }
    },
    methods: {
        checkSex() {
            if (this.$store.state.current_user.sex == "male") {
                this.male = true;
            }
            if (this.$store.state.current_user.sex == "female") {
                this.female = true;
            }
        },
        questionRoullette(e) {
            this.shadow = e;
        },
        maleClick() {
            if (this.playerIsFide == false) {
                this.female = false;
            }
        },
        femaleClick() {
            if (this.playerIsFide == false) {
                this.male = false;
            }
        },
        closePolicy() {
            //this.securityPopup = false;
            this.termsPopup = false;
            // this.privacyPopup = false;
        },
        fideFill() {
            fetch(process.env.VUE_APP_URL + `/users_rating_from_fide_v2/${this.fide_id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => (this.user_fide = data))
                //  .then(data => console.log(data))
                .then(this.fillDataFideId);
        },
        payByWallet() {
            //    console.log('1',this.tournament.event_uuid)
            //    console.log('2',this.nick)
            //    console.log('3',this.choosenFee)
            //    console.log('4',this.choosenFeeAccommodation)

            let customData = {
                player_nick_name: this.nick,
            };

            fetch(process.env.VUE_APP_URL + "/tournament_players_register_current_user_via_wallet", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    event_uuid: this.tournament.event_uuid,
                    amount: this.choosenFee,
                    custom_data: customData,
                }),
            })
                .then(response => response.json())
                .then(data => (this.responseWallet = data))
                //.then(data => console.log(data))
                .then(this.regTourWallet);
        },
        regTourWallet() {
            let newValue = this.$store.state.walletSum - this.choosenFee;
            this.$store.commit("SET_WALLET", newValue);
            if (this.responseWallet.internal_trans_count) {
                this.$router.push({
                    name: "RegisterThankYou",
                    params: { id: this.tournament.event_uuid },
                });
            }

            // console.log("response", this.responseWallet);
        },
        goToTeamPayment(e) {
            this.company_data = e;
            // console.log("eeee", this.company_data);
            // this.registerFormCompany = false;
            this.registerForm = false;
            this.walletPayment();
            this.nextCompany();
        },
        fillDataFideId() {
            if (this.user_fide.reason == "No record found") {
                return;
            }
            this.playerIsFide = true;
            this.inactiveFields = false;
            if (this.user_fide.reason == "Requested player does not exist") {
                this.notExist = true;
            } else {
                this.notExist = false;
                //  console.log(this.user_fide.name);

                if (this.user_fide && this.user_fide.name !== undefined && this.user_fide.name.includes(",")) {
                    this.name_first = this.user_fide.name.split(",")[1];
                    this.name_last = this.user_fide.name.split(",")[0];
                } else {
                    this.name_first = this.user_fide.name.split(" ")[1].trim();
                    this.name_last = this.user_fide.name.split(" ")[0].trim();
                }
                if (this.user_fide.title == "Grandmaster") {
                    this.title = "GM";
                    this.title_uuid = "4ffbf6b5-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "Woman Intl. Master") {
                    this.title = "WIM";
                    this.title_uuid = "b9238c86-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "International Master") {
                    this.title = "IM";
                    this.title_uuid = "4ffbf6b4-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "FIDE Master") {
                    this.title = "FM";
                    this.title_uuid = "4ffbf6b3-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "Woman Grandmaster") {
                    this.title = "WGM";
                    this.title_uuid = "d18adaae-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "Candidate Master") {
                    this.title = "CM";
                    this.title_uuid = "4ffbf6b2-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "Woman Candidate Master") {
                    this.title = "WCM";
                    this.title_uuid = "91f90e7e-1ec7-11ec-a733-0d4e300cf032";
                } else if (this.user_fide.title == "Woman FIDE Master") {
                    this.title = "WFM";
                    this.title_uuid = "a6019274-1ec7-11ec-a733-0d4e300cf032";
                }

                this.rating_b = this.user_fide.blitz_elo;
                this.rating_r = this.user_fide.rapid_elo;
                this.rating = this.user_fide.standard_elo;
                if (this.user_fide.sex == "Male") {
                    this.male = true;
                    this.female = false;
                } else if (this.user_fide.sex == "Female") {
                    this.female = true;
                    this.male = false;
                }

                if (this.rating_b == "Notrated" || this.rating_b == undefined) {
                    this.rating_b = 0;
                }
                if (this.rating == "Notrated" || this.rating == undefined) {
                    this.rating_s = 0;
                }
                if (this.rating_r == "Notrated" || this.rating_r == undefined) {
                    this.rating_r = 0;
                }
            }
        },
        // openSecurity() {
        //     this.securityPopup = true;
        //     this.returnPolicyPopup = false;
        //     this.privacyPopup = false;
        // },
        openTerms() {
            this.termsPopup = true;
            if (window.innerWidth < 500) {
                window.scrollBy(0, 500);
            }

            // this.securityPopup = false;
            // this.privacyPopup = false;
        },
        // openPrivacy() {
        //     this.privacyPopup = true;
        //     this.returnPolicy = false;
        //     this.returnPolicyPopup = false;
        // },
        backInner() {
            if (this.registerFormCompany == true) {
                this.registerFormCompany = false;
            }
            if (this.nextPage === true) {
                this.nextPage = false;
            } else if (this.registerForm === true) {
                this.registerForm = false;
            } else {
                //this.$router.go(-1);
                if (localStorage.getItem("to_event_from") == "Home") {
                    this.$router.push({ name: "HomePage" });
                } else if (localStorage.getItem("to_event_from") == "Calendar") {
                    this.$router.push({ name: "TournamentCalendar" });
                } else if (localStorage.getItem("to_event_from") == "Notification") {
                    this.$router.push({ name: "Notifications" });
                } else if (localStorage.getItem("to_event_from") == "Wallet") {
                    this.$router.push({ name: "WalletOutpost" });
                } else if (localStorage.getItem("to_event_from") == "public") {
                    this.$router.push({
                        name: "Publicprofile",
                        params: { id: localStorage.getItem("to_event_from_org") },
                    });
                } else {
                    this.$router.go(-1);
                }
            }
        },
        setData() {
            // console.log('jhgjh',this.tournament)
            if (this.logedIn) {
                this.name_last = this.user.name_last;
                this.name_first = this.user.name_first;
                this.email = this.user.email;
                this.fide_id = this.user.user_fide;
                if (
                    (this.user.rating_standard == 0 && this.user.rating_blitz == 0 && this.user.rating_rapid == 0) ||
                    (this.user.fide_id == "/" && this.user.uscf_id == "/") ||
                    (this.user.fide_id == null && this.user.uscf_id == null) ||
                    (this.user.rating_standard == null &&
                        this.user.rating_blitz == null &&
                        this.user.rating_rapid == null &&
                        this.user.fide_id == null)
                ) {
                    this.checkbox = true;
                } else if (
                    this.user.fide_id !== "/" &&
                    this.user.fide_id !== "" &&
                    this.user.fide_id !== null &&
                    this.user.fide_id !== undefined
                ) {
                    this.fide_id = this.user.fide_id;
                } else {
                    this.fide_id = this.user.uscf_id;
                    this.uscf_bool = true;
                }
            }
            if (this.user.sex == "Male") {
                this.male = true;
            }
            if (this.user.sex == "Female") {
                this.female = true;
            }
        },
        getOffset() {},
        checkInnerOrg() {
            this.loadTournament = true;
            if (this.tournament.event_is_corporate == true) {
                this.payCompanyBill = true;
            }
            if (this.tournament.price_currency == "EUR") {
                this.currency = "€";
            } else if (this.tournament.price_currency == "GBP") {
                this.currency = "£";
            } else if (this.tournament.price_currency == "USD") {
                this.currency = "$";
            } else if (this.tournament.price_currency == "TRY") {
                this.currency = "₺";
            }
            if (this.tournament.event_timezone !== null) {
                // this.getOffset()
                const options = { timeZone: this.tournament.event_timezone, timeZoneName: "longOffset" };
                // console.log("optionica",options)
                let zoneMinusPlus = Intl.DateTimeFormat("en-GB", { timeStyle: "long" }, [], options)
                    .format(new Date())
                    .split("GMT")[1];

                //   console.log("kokokoko1",zoneMinusPlus)

                if (zoneMinusPlus == undefined || (zoneMinusPlus.length !== 5 && zoneMinusPlus.length !== 6)) {
                    zoneMinusPlus = Intl.DateTimeFormat([], options).format(new Date()).slice(-6);
                    // console.log("option",zoneMinusPlus.length)
                    this.diffCount = true;
                }

                if (zoneMinusPlus.length == 5) {
                    let b = "0";
                    let position = 1;
                    zoneMinusPlus = [zoneMinusPlus.slice(0, position), b, zoneMinusPlus.slice(position)].join("");
                }
                if (zoneMinusPlus.length == 6 && zoneMinusPlus[0] !== "-" && zoneMinusPlus[0] !== "+") {
                    // console.log('llll',zoneMinusPlus[0])
                    zoneMinusPlus = "+00:00";
                }

                if (this.tournament.event_start_minute < 10) {
                    this.tournament.event_start_minute = "0" + this.tournament.event_start_minute;
                }
                if (this.tournament.event_start_hour < 10) {
                    this.tournament.event_start_hour = "0" + this.tournament.event_start_hour;
                }

                let dataToFormat =
                    this.tournament.event_date_from +
                    "T" +
                    this.tournament.event_start_hour +
                    ":" +
                    this.tournament.event_start_minute +
                    ":" +
                    "00";

                const d = new Date(dataToFormat);
                console.log("d", d);

                let usertimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                /*      if(d.getTimezoneOffset()>0){
                this.hourDiff2=Math.floor(d.getTimezoneOffset()/60)
                this.minuteDiff2 = Math.abs(d.getTimezoneOffset() % 60);
                if(this.hourDiff2<10 ){
                    this.hourDiff2='-0'+this.hourDiff2
                }
                else{
                    this.hourDiff2='-0'+this.hourDiff2
                }
                if(this.minuteDiff2<10 ){
                    this.minuteDiff2='0'+this.minuteDiff2
                }
              
            }else{
                this.hourDiff2=(Math.floor( Math.abs(d.getTimezoneOffset()/60)))
                this.minuteDiff2 = Math.abs(d.getTimezoneOffset() % 60);
                if(this.hourDiff2<10 ){
                    this.hourDiff2='+0'+this.hourDiff2
                }else{this.yearTour
                    this.hourDiff2='+'+this.hourDiff2
                }
                if(this.minuteDiff2<10 ){
                    this.minuteDiff2='0'+this.minuteDiff2 
                }
               
            }  */

                if (this.diffCount == true) {
                    // console.log("kokokoko1",zoneMinusPlus)
                    this.dataToFormat2 =
                        this.tournament.event_date_from +
                        "T" +
                        this.tournament.event_start_hour +
                        ":" +
                        this.tournament.event_start_minute +
                        ":" +
                        "00" +
                        zoneMinusPlus;
                } else {
                    this.dataToFormat2 =
                        this.tournament.event_date_from +
                        "T" +
                        this.tournament.event_start_hour +
                        ":" +
                        this.tournament.event_start_minute +
                        ":" +
                        "00" +
                        "+02:00";
                }
                //   console.log("kokokoko2",this.dataToFormat2)
                const d3 = new Date(this.dataToFormat2);
                const d2 = new Intl.DateTimeFormat("en-GB", {
                    dateStyle: "short",
                    timeStyle: "long",
                    timeZone: usertimezone,
                }).format(d3);

                // console.log("kokokoko2",d2)
                // const d4=new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long', timeZone: this.tournament.event_timezone }).format(d3)
                // console.log('nikro2',d4.slice(-10,-4))
                this.yearTour = d2.slice(6, 10);
                this.dateTour = d2.slice(0, 2);
                this.monthTour = d2.slice(3, 5);
                this.hourTour = d2.slice(12, 14);
                this.minuteTour = d2.slice(15, 17);

                //  if(d4.slice(-10,-4).includes('PM')){
                //    this.afterhour='PM'
                //}else{
                //  this.afterhour='AM'
                // }
                // this.hour=d2.slice()
            }

            // let time2=new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long', timeZone: 'Asia/Kabul' }).format(d)

            // Expected output: "Sunday, 20 December 2020 at 14:23:16 GMT+11"

            /*   let zonedHours = new Intl.DateTimeFormat('en-US', {timeZone: "America/New_York"});
        var timeZoneUSA = intlDateObj.format(new Date());
      
           let zonedHours=new Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeStyle: 'long', timeZone: 'America/Dawson' }).format(new Date())
       

        const str = new Date().toLocaleString('en-US', { timeZone: 'America/Dawson' });
     
            /*let zonedMinute=new Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeStyle: 'long', timeZone: this.tournament.event_timezone }).format(new Date()).slice(15,17)
          // let localTime = new Date().toLocaleTimeString({timeZoneName:'short'}).slice(0,2)
        let localMinute = new Date().toLocaleTimeString({timeZoneName:'short'}).slice(3,5)
        let localHours = new Date().toLocaleTimeString({timeZoneName:'short'}).slice(0,2)
        if(zonedHours=="00" ){
            zonedHours=24
        }
       
        this.minuteDiff=localMinute-zonedMinute
        this.hoursDiff=localHours-zonedHours
         */
            // Expected output: "Sunday, 20 December 2020 at 14:23:16 GMT+11"

            if (this.tournament.organiser_uuid == localStorage.getItem("id")) {
                this.$router.push({ name: "TournamentInnerOrg", params: { id: this.tournament.event_uuid } });
            } else {
                this.pageLoad = true;
            }
            if (this.tournament.event_start_hour !== null && this.tournament.event_start_minute !== null) {
                let tourHoursLocale = this.tournament.event_start_hour - this.hoursDiff;

                let tourMinuteLocale = this.tournament.event_start_minute - this.minuteDiff;

                this.minutes = tourMinuteLocale;
                this.hours = tourHoursLocale;
                if (this.hours < 0) {
                    this.hours = 24 + this.hours;
                }
                if (this.hours < 10) {
                    this.hours = "0" + this.hours;
                }

                if (this.minutes < 10) {
                    this.minutes = "0" + this.minutes;
                }
                /*   if (this.tournament.event_start_hour > 12) {
                    this.hours = this.tournament.event_start_hour - 12;
                    this.ampm = "PM";
                } else {
                    this.hours = this.tournament.event_start_hour;
                    this.ampm = "AM";
                }
                if (this.tournament.event_timezone.slice(0, 1) == "+") {
                    this.hours = this.hours - Number(this.tournament.event_timezone.slice(1, 3));
                } else {
                    this.hours = this.hours + Number(this.tournament.event_timezone.slice(1, 3));
                }

                if (this.tournament.event_timezone.slice(0, 1) == "+") {
                    this.minutes = this.minutes - Number(this.tournament.event_timezone.slice(4, 6));
                } else {
                    this.minutes = this.minutes + Number(this.tournament.event_timezone.slice(4, 6));
                }

                this.hours = this.hours + timezoneHours;
                if (timezoneHours > -1) {
                    this.minutes = this.minutes + timezoneMinutes;
                } else {
                    this.minutes = this.minutes - timezoneMinutes;
                }

                if (this.minutes > 59) {
                    this.minutes = 60 - this.minutes;
                    this.hours++;
                }
                if (this.minutes < 0) {
                    this.minutes = 60 + this.minutes;
                    this.hours--;
                }

                if (this.hours < 0) {
                    if (this.ampm == "PM") {
                        this.ampm = "AM";
                        this.hours = 12 + this.hours;
                    } else {
                        this.ampm = "PM";
                        this.hours = 12 + this.hours;
                    }
                }

                

                if (this.hours == "00") {
                    this.hours = "12";
                }
                */
            }
        },
        feeAccommodationSelection(fee) {
            this.choosenFeeAccommodation = fee.price_amount;
            this.choosenFeeAccommodationName = fee.price_name;
            this.textEntreyAccFee =
                fee.price_name.substring(10, 0) + " " + "-" + " " + this.currency + fee.price_amount;
            this.entryFees = false;
            this.chooseAcc = false;
        },
        feeSelection(fee) {
            this.choosenFee = fee.price_amount;
            this.choosenFeeName = fee.price_name;
            this.textEntreyFee = fee.price_name.substring(10, 0) + " " + "-" + " " + this.currency + fee.price_amount;
            this.entryFees = false;
        },
        cancelRegister() {
            this.registerForm = false;
            this.registerFormCompany = false;
        },

        register() {
            if (this.tournament.event_is_corporate == true && this.logedIn == true) {
                // this.$router.push({ name: "Signin" })
                //  this.registerForm = true;
                fetch(process.env.VUE_APP_URL + "/wallet_sum", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                })
                    .then(response => response.json())
                    .then(data => (this.walletSum = data));
                this.registerFormCompany = true;
            } else if (this.logedIn == false && this.tournament.event_is_corporate == true) {
                this.$router.push({ path: `/login?state=${this.event_id}` });
            } else if (this.logedIn) {
                fetch(process.env.VUE_APP_URL + "/wallet_sum", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                })
                    .then(response => response.json())
                    .then(data => (this.walletSum = data));
            }
            if (this.logedIn) {
                if (
                    (this.$store.state.current_user.name_first == "" ||
                        this.$store.state.current_user.name_last == "" ||
                        this.$store.state.current_user.name_first == null ||
                        this.$store.state.current_user.name_last == null) &&
                    this.tournament.event_is_corporate !== true
                ) {
                    this.$router.push("/edit-personal");
                } else if (this.tournament.event_is_corporate == true) {
                    this.registerFormCompany = true;
                } else {
                    this.registerForm = true;
                }
            } else {
                this.registerForm = true;
            }
        },
        walletPayment() {
            if (this.logedIn && this.tournament.price_currency == "EUR") {
                if (this.walletSum.total > this.choosenFee + this.choosenFeeAccommodation) {
                    console.log("ima u walletu");

                    this.noWallet = false;
                } else {
                    console.log("nema u walletu");
                }
            }
        },
        paypalActive() {
            let name = this.name_first;
            let surname = this.name_last;
            let mail = this.email;
            let checkboxFide = this.checkbox;
            let fide = this.fide_id;
            let nickPlayer = this.nick;
            let uuid = this.tournament.event_uuid;
            let tourName = this.tournament.event_name;
            let fee = this.choosenFee + this.choosenFeeAccommodation;
            let choosenFeeString = this.choosenFee.toString();
            let choosenFeeAccommodationString = this.choosenFeeAccommodation.toString();
            let feeString = fee.toString();
            let eventId = this.$route.params.id;
            //let choosenFee = this.choosenFee;
            // let choosenFeeAccommodation = this.choosenFeeAccommodation;
            if (this.male == true) {
                this.player_gender = "Male";
            } else {
                this.player_gender = "Female";
            }
            let player_gender_paypal = this.player_gender;
            let rating_paypal = this.rating;
            let rating_b_paypal = this.rating_b;
            let rating_r_paypal = this.rating_r;
            let title_uuid_paypal = this.title_uuid;
            let currency = this.tournament.price_currency;
            if (
                this.choosenFeeAccommodation !== "" &&
                this.choosenFeeAccommodation !== undefined &&
                this.choosenFeeAccommodation !== 0 &&
                this.choosenFeeAccommodation !== null
            ) {
                this.purchase = {
                    custom_id: uuid,
                    amount: {
                        currency_code: currency,
                        value: feeString,
                        breakdown: {
                            item_total: {
                                currency_code: currency,
                                value: feeString,
                            },
                        },
                    },
                    items: [
                        {
                            name: `fee for event ${tourName}`,
                            description: "",
                            unit_amount: {
                                currency_code: currency,
                                value: choosenFeeString,
                            },
                            quantity: "1",
                            sku: "fee_registration",
                        },
                        {
                            name: `Accommodation fee for ${tourName}`,
                            description: "",
                            unit_amount: {
                                currency_code: currency,
                                value: choosenFeeAccommodationString,
                            },
                            quantity: "1",
                            sku: "fee_accommodation",
                        },
                    ],
                };
            } else {
                this.purchase = {
                    custom_id: uuid,
                    amount: {
                        currency_code: currency,
                        value: feeString,
                        breakdown: {
                            item_total: {
                                currency_code: currency,
                                value: feeString,
                            },
                        },
                    },
                    items: [
                        {
                            name: `fee for event ${tourName}`,
                            description: "",
                            unit_amount: {
                                currency_code: currency,
                                value: choosenFeeString,
                            },
                            quantity: "1",
                            sku: "fee_registration",
                        },
                    ],
                };
            }
            let purchase = this.purchase;

            const script = document.createElement("script");
            script.src = `https://www.paypal.com/sdk/js?client-id=${this.paypalParams.appid}&currency=${this.tournament.price_currency}`;
            script.addEventListener("load", () => {
                window.paypal
                    .Buttons({
                        style: {
                            shape: "pill",
                            color: "black",
                            layout: "horizontal",
                            label: "pay",
                            tagline: false,
                        },

                        createOrder: function () {
                            if (localStorage.getItem("token")) {
                                return fetch(process.env.VUE_APP_URL + "/paypal-orders", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                                    },
                                    body: JSON.stringify({
                                        amount: feeString,
                                        event_uuid: uuid,
                                        name_first: name,
                                        name_last: surname,
                                        email: mail,
                                        fide_id: checkboxFide ? "" : fide,
                                        player_nick_name: nickPlayer,
                                        is_rated: checkboxFide,
                                        purchase_unit: purchase,
                                    }),
                                })
                                    .then(response => response.json())
                                    .then(order => order.id);
                            } else {
                                return fetch(process.env.VUE_APP_URL + "/paypal-orders", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        //  Authorization: `Bearer ${localStorage.getItem("token")}`
                                    },
                                    body: JSON.stringify({
                                        amount: feeString,
                                        event_uuid: uuid,
                                        name_first: name,
                                        name_last: surname,
                                        email: mail,
                                        fide_id: checkboxFide ? "" : fide,
                                        player_nick_name: nickPlayer,
                                        is_rated: checkboxFide,
                                        player_gender: player_gender_paypal,
                                        player_rating_standard: rating_paypal,
                                        player_rating_blitz: rating_b_paypal,
                                        player_rating_rapid: rating_r_paypal,
                                        player_title_uuid: title_uuid_paypal,
                                        player_phone: this.player_phone,
                                        purchase_unit: purchase,
                                    }),
                                })
                                    .then(response => response.json())
                                    .then(order => order.id);
                            }
                        },
                        onApprove: function (data, actions) {
                            if (localStorage.getItem("token")) {
                                return fetch(process.env.VUE_APP_URL + `/paypal-orders/${data.orderID}/capture`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                                    },
                                    body: JSON.stringify({
                                        amount: feeString,
                                        event_uuid: uuid,
                                        name_first: name,
                                        name_last: surname,
                                        email: mail,
                                        fide_id: checkboxFide ? "" : fide,
                                        player_nick_name: nickPlayer,
                                        is_rated: checkboxFide,
                                        purchase_unit: purchase,
                                    }),
                                })
                                    .then(response => response.json())

                                    .then(orderData => {
                                        console.log("Capture result1", orderData, JSON.stringify(orderData, null, 2));
                                        //  console.log("Capture result2", orderData.purchase_units[0].payments.captures[0].status);
                                        actions.redirect(`https://app.outpostchess.com/register-thank-you/${eventId}`);
                                    });
                            } else {
                                return fetch(process.env.VUE_APP_URL + `/paypal-orders/${data.orderID}/capture`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                        amount: feeString,
                                        event_uuid: uuid,
                                        name_first: name,
                                        name_last: surname,
                                        email: mail,
                                        fide_id: checkboxFide ? "" : fide,
                                        player_nick_name: nickPlayer,
                                        is_rated: checkboxFide,
                                        player_gender: player_gender_paypal,
                                        player_rating_standard: rating_paypal,
                                        player_rating_blitz: rating_b_paypal,
                                        player_rating_rapid: rating_r_paypal,
                                        player_title_uuid: title_uuid_paypal,
                                        purchase_unit: purchase,
                                    }),
                                })
                                    .then(response => response.json())
                                    .then(orderData => {
                                        console.log("Capture result", orderData, JSON.stringify(orderData, null, 2));
                                        actions.redirect(`https://app.outpostchess.com/register-thank-you/${eventId}`);
                                    });
                            }
                        },
                        onError: function (err) {
                            console.log(err);
                        },
                    })
                    .render("#paypal-button-container");
            });

            document.body.appendChild(script);
        },
        nextCompany() {
            // console.log("3232",this.company_data)
            this.choosenFee = Number(this.company_data.choosenFee);
            this.choosenFeeAccommodation = Number(this.company_data.choosenFeeAccommodation);
            this.nextPage = true;

            window.scrollTo(0, 0);
        },
        next() {
            fetch(
                process.env.VUE_APP_URL +
                    `organiser_event_players_is_email_registered/${this.tournament.event_uuid}?email=${this.email}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            )
                .then(response => response.json())
                .then(data => (this.checkMail = data))
                // .then(data => console.log("ide upis", data.exists))

                .then(this.checkMailStep2);
            //    this.nextCheckOver
        },
        checkMailStep2() {
            // console.log("1", this.checkMail.exists);
            if (this.checkMail.exists == false) {
                this.nextCheckOver();
            } else {
                this.dubbleMail = true;
            }
        },
        nextCheckOver() {
            this.walletPayment();
            if (this.choosenFee == 0 && this.textEntreyFee !== "" && this.choosenFeeAccommodation == 0) {
                this.registrationGo();
                return;
            }

            this.choosenFee = Number(this.choosenFee);
            this.choosenFeeAccommodation = Number(this.choosenFeeAccommodation);
            if (this.fide_id !== "" && this.fide_id !== null && this.fide_id !== undefined) {
                for (this.i = 0; this.i < this.organiser_evet_list?.length; this.i++) {
                    if (this.organiser_evet_list[this.i].player_fide_id == this.fide_id) {
                        this.dubbleFideId = true;
                        this.notExist = false;
                        console.log(this.dubbleFideId);

                        if (this.organiser_evet_list[this.i].player_fide_id !== "/") {
                            return;
                        }
                    }
                }
            }

            // for (this.i = 0; this.i < this.organiser_evet_list?.length; this.i++) {
            //     if (this.organiser_evet_list[this.i].player_email == this.email) {
            //         this.dubbleMail = true;

            //         return;
            //     }
            // }

            if (this.email !== "") {
                let regex = new RegExp(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/);
                if (regex.test(this.email) == false) {
                    this.errorMail = true;
                    this.colored = true;
                    // console.log(this.email);
                    return;
                }
            } else {
                this.colored = true;

                return;
            }

            if (
                this.logedIn == false &&
                (this.name_first == "" ||
                    this.name_last == "" ||
                    this.name_first == undefined ||
                    this.name_last == undefined)
            ) {
                this.colored = true;
                return;
            }

            if (this.tournament.event_is_online && this.nick == "") {
                this.colored = true;
                return;
            }

            if (this.checkbox !== true && (this.fide_id == "" || this.fide_id == null || this.fide_id == undefined)) {
                this.colored = true;

                return;
            }

            if (this.user_fide.rapid_elo == "Notrated") {
                this.user_fide.rapid_elo = 0;
            }
            if (this.user_fide.blitz_elo == "Notrated") {
                this.user_fide.blitz_elo = 0;
            }
            if (this.user_fide.standard_elo == "Notrated") {
                this.user_fide.standard_elo = 0;
                this.rating = this.user_fide.standard_elo;
            }

            if (this.choosenFee == "" && this.choosenFee !== 0) {
                this.colored = true;
                return;
            }
            if (this.choosenFee == 0 && this.choosenFeeAccommodation > 0) {
                console.log("ok");
            } else if (this.choosenFee == 0) {
                this.colored = true;
                return;
            }
            if (
                (this.logedIn && (this.user.fide_id == null || this.user.fide_id == "/") && this.fide_id) ||
                this.checkbox == true ||
                this.rating_standard == null ||
                this.rating_standard == "/" ||
                this.rating_standard == "" ||
                this.rating_standard == 0
            ) {
                if (this.checkbox == true) {
                    this.fide_id = "/";
                }

                fetch(process.env.VUE_APP_URL + "/current_user_info", {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify({
                        fide_id: this.fide_id,
                        sex: this.player_gender,
                        rating_standard: this.user_fide.standard_elo,
                        rating_rapid: this.user_fide.rapid_elo,
                        rating_blitz: this.user_fide.blitz_elo,
                    }),
                }).then(response => response.json());
                // .then(data => console.log(data));
            }

            this.nextPage = true;

            window.scrollTo(0, 0);
        },
        openDrop() {
            this.entryFees = !this.entryFees;
            this.chooseAcc = false;
            if (this.tournament.price.length > 3) {
                this.feeClicked = true;
            }
        },
        openDropAcc() {
            this.chooseAcc = !this.chooseAcc;
            this.entryFees = false;
        },
        load() {
            for (let i = 0; i < this.organiser_evet_list.length; i++) {
                //('1',this.organiser_evet_list[i].player_uuid);

                if (
                    this.organiser_evet_list[i].player_uuid === localStorage.getItem("id") &&
                    this.organiser_evet_list[i].player_uuid !== null
                ) {
                    this.registerOk = false;
                }
            }
            this.loaded = true;
            setTimeout(() => {
                this.loadHeader = true;
            }, 30);
        },
        async registrationGo(e) {
            if (this.fide_id !== "" && this.fide_id !== null && this.fide_id !== undefined && this.fide_id !== "/") {
                for (this.i = 0; this.i < this.organiser_evet_list?.length; this.i++) {
                    if (this.organiser_evet_list[this.i].player_fide_id == this.fide_id) {
                        this.dubbleFideId = true;
                        this.notExist = false;

                        return;
                    }
                }
            }

            if (this.male == true) {
                this.player_gender = "Male";
            } else {
                this.player_gender = "Female";
            }

            let regex = new RegExp(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/);
            if (regex.test(this.email) == false) {
                this.errorMail = true;
                this.colored = true;
                //console.log(this.email);
                return;
            }

            if (
                this.logedIn == false &&
                (this.name_first == "" ||
                    this.name_last == "" ||
                    this.name_first == undefined ||
                    this.name_last == undefined)
            ) {
                this.colored = true;
                return;
            }
            if ((this.tournament.event_is_online && this.nick == "") || (this.male == false && this.female == false)) {
                this.colored = true;
                return;
            }
            if (this.checkbox == false && (this.fide_id == null || this.fide_id == "" || this.fide_id == undefined)) {
                this.colored = true;
                return;
            }

            if (this.user_fide.rapid_elo == "Notrated") {
                this.user_fide.rapid_elo = 0;
            }
            if (this.user_fide.blitz_elo == "Notrated") {
                this.user_fide.blitz_elo = 0;
            }
            if (this.user_fide.standard_elo == "Notrated") {
                this.user_fide.standard_elo = 0;
                this.rating = this.user_fide.standard_elo;
            }

            if (
                this.title !== "GM" &&
                this.title !== "WGM" &&
                this.title !== "IM" &&
                this.title !== "WIM" &&
                this.title !== "CM" &&
                this.title !== "WCM" &&
                this.title !== "FM" &&
                this.title !== "WFM"
            ) {
                this.title = this.title_start;
            }
            if (this.title == "GM") {
                this.title2 = "4ffbf6b5-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "WIM") {
                this.title2 = "b9238c86-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "IM") {
                this.title2 = "4ffbf6b4-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "FM") {
                this.title2 = "4ffbf6b3-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "WGM") {
                this.title2 = "d18adaae-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "CM") {
                this.title2 = "4ffbf6b2-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "WCM") {
                this.title2 = "91f90e7e-1ec7-11ec-a733-0d4e300cf032";
            } else if (this.title == "WFM") {
                this.title2 = "a6019274-1ec7-11ec-a733-0d4e300cf032";
            }

            this.rating = Number(this.rating);
            //   if (this.user.fide_id == null && (this.fide_id == null || "")) {
            //       this.colored = true;
            //       return;
            //   }

            if (this.logedIn) {
                //

                if (
                    ((this.user.fide_id == null || this.user.fide_id == "/") && this.fide_id) ||
                    this.checkbox == true ||
                    this.rating_standard == null ||
                    this.rating_standard == "/" ||
                    this.rating_standard == "" ||
                    this.rating_standard == 0
                ) {
                    if (this.checkbox == true) {
                        this.fide_id = "/";
                    }

                    await fetch(process.env.VUE_APP_URL + "/current_user_info", {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                        body: JSON.stringify({
                            fide_id: this.fide_id,
                            sex: this.player_gender,
                            rating_standard: this.user_fide.standard_elo,
                            rating_rapid: this.user_fide.rapid_elo,
                            rating_blitz: this.user_fide.blitz_elo,
                            name_first: this.name_first,
                            name_last: this.name_last,
                        }),
                    })
                        .then(response => response.json())
                        //  .then(data => console.log(data))
                        .then((this.loader = true))
                        .then(setTimeout(() => this.regLogUser(e), 2000));
                } else if (this.user.sex == null) {
                    await fetch(process.env.VUE_APP_URL + "/current_user_info", {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                        body: JSON.stringify({
                            sex: this.player_gender,
                        }),
                    })
                        .then(response => response.json())
                        //.then(data => console.log(data))
                        .then((this.loader = true))
                        .then(setTimeout(() => this.regLogUser(e), 3000));
                } else {
                    this.regLogUser(e);
                }
            } else {
                if (this.rating == undefined || this.rating == null || this.rating == "" || isNaN(this.rating)) {
                    this.rating = 0;
                }

                this.rating = parseInt(this.rating);

                try {
                    const res = await fetch(process.env.VUE_APP_URL + "/tournament_players_register_other_user", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            event_uuid: this.tournament.event_uuid,
                            name_first: this.name_first,
                            name_last: this.name_last,
                            email: this.email,
                            fide_id: this.checkbox ? "" : this.fide_id,
                            player_nick_name: this.nick,
                            is_rated: this.checkbox,
                            player_gender: this.player_gender,
                            player_rating_standard: this.rating,
                            player_rating_blitz: this.rating_b,
                            player_rating_rapid: this.rating_r,
                            player_title_uuid: this.title_uuid,
                            player_phone: this.player_phone,
                        }),
                    });
                    this.register = await res.json();
                    this.goTo(this.register);
                    //  console.log("proba",this.register);
                } catch (e) {
                    console.error(e.message);
                    this.errorMail = true;
                    // this.dubbleMail = true;
                }
            }
        },

        registerWithoutPayment() {
            // fetch(process.env.VUE_APP_URL + "fide_registration_send_email", {
            //                 method: "POST",
            //                 headers: {
            //                     "Content-Type": "application/json",
            //                     Authorization: `Bearer ${localStorage.getItem("token")}`,
            //                 },
            //             })
            this.fideWithoutPay = true;

            //console.log('kjshgaksgj',this.company_data.company_town)
            fetch(process.env.VUE_APP_URL + "/company", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    company_name: this.company_data.company_name,
                    company_vat: this.company_data.company_vat,
                    company_address: this.company_data.company_address,
                    company_postal_code: this.company_data.company_postal_code,
                    company_country: this.company_data.company_country,
                    company_phone: this.company_data.company_phone,
                    company_town: this.company_data.company_town,
                    company_picture: this.company_data.company_picture,

                    event_is_paid: false,
                }),
            }).then(response => response.json());

            this.regLogUser();
        },
        async regLogUser(e) {
            try {
                const res = await fetch(process.env.VUE_APP_URL + "/tournament_players_register_current_user", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify({
                        event_uuid: this.tournament.event_uuid,
                        player_nick_name: this.nick,
                    }),
                });
                this.register = await res.json();

                this.goTo(e);
                this.colored = false;
            } catch (e) {
                console.error(e.message);
                this.errorMail = true;
                // this.dubbleMail = true;
            }
            // if(this.tournament.event_is_corporate){
            //     fetch(process.env.VUE_APP_URL + "/company", {
            //         method: "POST",
            //         headers: {
            //             "Content-Type": "application/json",
            //             Authorization: `Bearer ${localStorage.getItem("token")}`,
            //         },
            //         body: JSON.stringify({
            //             company_name: this.company_data.company_name,
            //             company_vat: this.company_data.company_vat,
            //             company_address: this.company_data.company_address,
            //             company_postal_code: this.company_data.company_postal_code,
            //             company_country: this.company_country,
            //             company_phone: this.company_data.company_phone,
            //             company_town: this.company_data.company_town,
            //             event_is_paid: "truelo",

            //         }),
            //     }).then(response => response.json())
            //     .then(data=> console.log('data',data));
            // }
        },
        goTo(e) {
            this.loader = false;

            if (e == 1) {
                this.nextPage = true;
            } else {
                if (!this.logedIn) {
                    this.$router.push({
                        name: "RegisterThankYou",
                        params: { id: this.tournament.event_uuid, plan: e, email: this.email },
                        //  query: { plan: this.tournament },
                    });
                } else {
                    if (this.fideWithoutPay == false) {
                        this.$router.push({
                            name: "RegisterThankYou",
                            params: { id: this.tournament.event_uuid, plan: e },
                        });
                    } else {
                        if (this.tournament.event_uuid == "e4a8fd32-d24d-11ee-aa36-66d6ee15200b") {
                            fetch(process.env.VUE_APP_URL + "/fide_registration_send_email", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                                },
                            }).then(response => response.json());
                            this.$router.push({
                                name: "RegisterThankYou",
                                params: { id: this.tournament.event_uuid, plan: e, state: this.fideWithoutPay },
                            });
                        } else {
                            this.$router.push({ name: "ParticipantsList", params: { id: this.tournament.event_uuid } });
                        }
                    }
                }

                //this.$router.push({ name: "ParticipantsList", params: { id: this.tournament.event_uuid } });
            }
        },
        registrationCancel() {
            this.registerForm = false;
        },

        toggleSidebarParent() {
            this.isSidebarOpen = !this.isSidebarOpen;
        },
        toggleSidebarParentClose() {
            this.isSidebarOpen = false;
        },
    },
};
</script>

<style scoped>
* {
    transition: 0s;
}
.tournament-desc >>> a {
    color: #c8a07d;
}
.paypal-button-number-1 {
    display: none !important;
}
.tournament-desc >>> a:hover {
    opacity: 0.7;
}
.hide {
    display: none !important;
}
.checkboxFide >>> .theme--light.v-application .v-application--wrap .theme--light.v-label {
    background-color: #171819 !important;
    color: #6f7381;
    caret-color: #c8a07d !important;
    border: #c8a07d !important;
}
.check-first >>> .theme--light.v-application .v-application--wrap .theme--light.v-label {
    color: #6f7381;
    caret-color: #c8a07d !important;
    border: #c8a07d !important;
    background-color: #171819 !important;
}
::placeholder {
    color: #6f7381;
}
.checkboxFide >>> .v-application {
    font-family: sans-serif !important;
}

.checkboxFide >>> .v-application .primary--text {
    caret-color: #c8a07d !important;
    color: #c8a07d !important;
}
.checkboxFide >>> .theme--light.v-application {
    background-color: #171819;
}

.checkboxFide >>> .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.checkboxFide >>> .v-messages {
    min-height: 0px;
}

.checkboxFide >>> .v-input__slot {
    margin-bottom: 0px;
}
.checkboxFide >>> label {
    margin-bottom: 0px !important;
}
.checkboxFide >>> .mdi-checkbox-blank-outline::before {
    color: #c8a07d;
}
.block-border-top {
    border-top: 0.5px solid #292a2e !important;
}
.checkboxFide {
    padding-right: 24px;
    display: flex;
}
.mobile {
    display: none !important;
}

.checkboxFide >>> .v-label {
    width: 80px;
    font-size: 14px !important;
}
</style>

<style scoped lang="scss">
$oc-gray: #6f7381;
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-align: start;
    transition: 0.3s;
}

.order-info {
    margin: 20px 0;
    flex-direction: column !important;
    justify-content: flex-start !important;
    div {
        margin: 5px 0;
        p {
            font-size: 16px;
        }
    }
}
.opacity0 {
    opacity: 0;
    transition: 0.15s;
}
.opacity1 {
    opacity: 1;
    transition: 0.15s;
}
.bill-button {
    margin-bottom: 10px;
    // background-color: #c8a07d;
    border: 1px solid #2c2e2f;
    border-radius: 23px;
    margin-top: 16px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: 700;
    font-size: 18px;
    color: #ffffff;
    &:hover {
        background-color: #2c2e2f;
        cursor: pointer;
    }
}
.bill-button2 {
    background-color: #2c2e2f;
    &:hover {
        opacity: 0.7;
    }
}
.monri-button {
    margin-bottom: 20px;
    background-color: #2c2e2f;
    border-radius: 23px;
    margin-top: 16px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: 700;
    font-size: 18px;
    color: #ffffff;
    &:hover {
        opacity: 0.7;
        cursor: pointer;
    }
}

.logotips-payment {
    a {
        img {
            margin-right: 24px;
            height: 30px;
            margin-top: 24px;
        }
    }
    @media screen and (max-width: 640px) {
        display: flex;
        flex-direction: row !important;
        a {
            img {
                margin-right: 12px;
            }
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.cont-time-control {
    flex-direction: column;
    div {
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }
    div:last-child {
        margin-top: 10px;
        align-items: center;
        p:last-child {
            margin-left: 10px;
        }
    }
}
.organizer-name {
    color: white;
    white-space: nowrap;
    @media screen and (max-width: 640px) {
        white-space: unset;
    }
}
.request-bill {
    color: #ceceda;
    font-weight: 600;
    margin-bottom: 12px;
    img {
        margin-bottom: 15px;
        &:hover {
            cursor: pointer;
            opacity: 0.7;
        }
    }
}
.opacity-paypal {
    opacity: 0.5;
}
.web {
    a {
        color: #11c6d1 !important;
    }
}
a {
    color: inherit;
    text-decoration: none;
}
.no-edit {
    cursor: default !important;
}
.contact-info {
    margin-top: 36px;
    align-items: flex-start !important;
    flex-direction: column;
}
.cont {
    div {
        a {
            word-break: break-all;
        }
    }
}
.tour-placeholder {
    padding: 15px 0px;
}
.loader {
    height: 70px;
    width: 100%;
    position: relative;
    img {
        position: absolute;
        height: 300px;
        width: 300px;
        top: -120px;
    }
}
.players-registred {
    padding-right: 25px;
    width: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 10px;
    p {
        width: auto !important;
        padding-right: 10px;
        padding-left: 10px;
    }
    img {
        height: 24px;
        padding-right: 0px !important;
        padding-bottom: 3px;
        &:hover {
            opacity: 0.7;
        }
    }
}
.billing-info-text {
    margin-bottom: 0px !important;
}
.pic-event-mobile {
    display: none !important;
}

.parent {
    display: flex;
    background-color: #171819;
    min-height: 100vh !important;
}

.wrapper {
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin-left: 3.188rem;
    margin-top: 2.188rem;
    background-color: #171819;
}
.confirm-button2-brown {
    background-color: #c8a07d;
    border: 1px solid #c8a07d;
    p {
        color: #ffffff !important;
    }
}
.wallet-pay-div {
    height: 150px;
    padding: 20px 10px;
}
.buttons-confirm-wallet {
    margin-top: 18px;
    display: flex;
    div {
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
            border: 0.5px solid #c8a07d;
            color: white;
            background-color: #202122 !important;
        }
        &:first-child {
            background-color: #c8a07d;
            color: white;
            border: 0.5px solid #c8a07d;
        }
    }
}
.popup-cont {
    flex-direction: column;
    padding: 26px 0 14px 0;
    position: absolute;
    top: 80px;
    max-height: 80% !important;
    overflow: scroll;
    min-height: 80%;
    background-color: #202122;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    h3 {
        margin: 0 15px;
        color: #ceceda;
        margin-bottom: 10px;
        margin-top: 6px;
        font-size: 20px !important;
    }
    h4 {
        color: #ceceda;
        font-size: 20px !important;
    }
    p {
        color: #ceceda;
        margin-top: 6px !important;
        margin-bottom: 8px !important;
        font-size: 12px !important;
    }
    @media screen and (max-width: 640px) {
        //min-height: 300px;
    }
}
.svg-back {
    position: absolute;

    right: 14px;
    top: 14px;
    &:hover {
        cursor: pointer;
        opacity: 0.7;
    }
}
::-webkit-scrollbar {
    display: none;
}
.confirm-button2 {
    height: 40px;
    width: 140px;
    margin-right: 10px;
    border-radius: 6px;
    border: 1px solid #6f7381;
    align-items: center !important;
    cursor: pointer;
    p {
        color: #ceceda;
        margin-right: 0 !important;
    }
}
.all-logos {
    display: flex;
    margin-left: 29px;
    @media screen and (max-width: 640px) {
        display: block;
        margin-bottom: 25px;
        padding-bottom: 25px;
    }
}
.bottom-border-payment {
    //border-bottom:0.5px solid #292a2e;
    padding-bottom: 20px;
    justify-content: flex-start !important;
    p {
        &:hover {
            cursor: pointer;
            color: white;
            opacity: 0.7;
        }
    }
}
.brown {
    background-color: #c8a07d;
    transition: 0.3s;
    &:hover {
        background-color: #2c2e2f;
    }
}
.bottom-border-payment-total {
    flex-direction: column;
    border-bottom: 0.5px solid rgb(111, 115, 129, 0.6);
    padding-bottom: 20px;
    div {
        justify-content: space-between !important;
        width: 100%;
    }
}
.payment-total {
    display: flex;
    justify-content: space-between !important;
    p:last-child {
        width: auto !important;
    }
}
.cont-header-reg {
    color: #c8a07d !important;
}
.confirm-button2-cream {
    height: 40px;
    width: 140px;
    margin-right: 10px;
    border-radius: 6px;
    align-items: center !important;
    background-color: #c8a07d;

    p {
        //  color: #3a332d !important;
        color: white !important;
        margin-right: 0 !important;
    }
}
.online-button {
    border: 0.5px solid rgba(111, 115, 129, 1);
    width: 110px !important;
    border-radius: 20px;
    padding: 3px 0;
    margin-right: 16px;
    height: 29px !important;
    p {
        color: #ceceda;
        text-align: center;
        margin: 0 !important;
        font-size: 14px !important;
    }
}
.fade-enter-active {
    transition: opacity 0.3s;
}
.fade-leave-active {
    transition: opacity 0s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.no-exist-div {
    position: absolute;
    width: 180px;
    top: -20px;
    left: -76px;
}

.no-exist-div2 {
    position: absolute;
    width: 250px;
    top: -20px;
    left: -136px;
}
.not_exist_message {
    font-size: 12px !important;
    color: rgba(242, 53, 141, 1) !important;
    margin: 0 !important ;
}
.online-button:hover {
    border: 0.5px solid #c8a07d;
    cursor: pointer;
}
.online-button-hover:hover {
    border: 0.5px solid #c8a07d;
    cursor: pointer;
}
.div-country {
    height: 20px;
    margin-bottom: 3px;
    position: relative;
}
.button2 {
    height: 40px;
    width: 140px;
    margin-right: 10px;
    border-radius: 6px;
    align-items: center !important;

    p {
        color: #6f7381 !important;
        margin-right: 0 !important
        ;
    }
}
.opacity7 {
    opacity: 0.3;
}
.input-line-throuhgh {
    text-decoration: line-through;
    opacity: 0.5;
}
.input-line-throuhgh::placeholder {
    text-decoration: line-through;
    opacity: 0.5;
}
.button2:hover {
    cursor: pointer;
    p {
        color: #ceceda !important;
    }
}

.confirm-button2:hover {
    border: 1px solid #c8a07d;
    background-color: #202122;
}
.confirm-button2-cream:hover {
    border: 1px solid #c8a07d;
    background-color: #202122;
    color: #ceceda !important;
    cursor: pointer;
}
.parent_correction {
    min-height: 140vh !important;
}
.flexend {
    margin-top: 20px;
    margin-bottom: 15px;
    width: 100%;
    padding-right: 15px;
    display: flex;
    justify-content: flex-end;
    div:last-child {
    }
    p {
        width: auto !important;
        color: #ceceda;
    }
}

span {
    color: #11c6d1;
}
.flexend3 {
    display: flex;
    p {
        color: #ceceda;
    }
}
.left-paypal {
    padding-left: 29px;
    padding-right: 29px;
    padding-top: 36px;
    position: relative;
    height: 100%;
    padding-bottom: 69px;
    color: #ceceda;
    p {
        margin-bottom: 12px;
        font-size: 16px;
    }
    @media screen and (max-width: 768px) {
        padding-top: 12%;
    }
}
.absolute {
    position: absolute;
    bottom: 10px;
}
.row-first {
    color: #c8a07d !important;
    font-size: 13px !important;
    min-width: 75px;
    margin-right: 10px !important;
}
.drop_fee:hover {
    background-color: #292a2e;
}
.margin-gender {
    margin-right: 12px;
}
.drop_fee {
    padding: 5px 10px 5px 14px;
    max-width: 100%;
    //  text-align: right;
    font-size: 16px;
}
input {
    font-size: 16px;
}
.flexend-mobile {
    display: none;
}
.colored {
    color: rgba(242, 53, 141, 1) !important;
    border-bottom: 1px solid rgba(242, 53, 141, 1) !important;
}
.colored2 {
    color: rgba(242, 53, 141, 1) !important;
}
.mobile-header {
    display: none;
}
.row-one-second {
    p {
        color: #11c6d1;
        margin-bottom: 15px;
    }
}

.input-registration {
    color: #ceceda;
    margin-left: 15px;
    width: 80%;
}
.no-border {
    border: none !important;
}
.cont {
    width: 100%;
}
.block-with-border {
    .cont {
        width: 100%;
    }
}

@media screen and (max-width: 1024px) {
    .parent {
        flex-direction: column;
    }
}

@media screen and (max-width: 768px) {
    .wallet-notification {
        display: none;
    }

    .parent {
        justify-content: center;
    }

    .wrapper {
        margin-left: 0;
        justify-content: center;
    }
}
.fee-dropdown {
    display: flex;
    border-bottom: 0.5px solid rgba(92, 94, 100, 1);
    //border-radius: 5px;
    padding: 5px 10px 5px 14px;
    min-width: 145px;
    max-width: 185px;
    width: auto;
    min-height: 36px;
    // background-color: #202122;
    position: relative;
    width: auto;
    justify-content: space-between;

    p {
        color: rgba(111, 115, 129, 1) !important;
    }
    img {
        margin-right: 0 !important;
    }
}
.fee-dropdown:hover {
    cursor: pointer;

    color: #ceceda;
}
.fee-dropdown2 {
    color: #ceceda;
}

.main-div {
    width: 51.188rem;
    margin: 0 auto 2rem auto;
}
.blue {
    color: #11c6d1 !important;
}
.cont-relative {
    position: relative;
}
.cont-absolute-row {
    position: absolute;
    left: 0;
    top: 25px;
    p {
        font-size: 12px !important;
        color: #f2358d !important;
    }
}
.bottom {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.row-one {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 2.813rem;
}
.no-edit {
    cursor: default !important;
}
.row-one:hover {
    opacity: 0.7;
    cursor: pointer;
}

.row-one img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1.145rem;
}

.row-one p {
    color: #6f7381;
    font-size: 24px;
    font-weight: 700;
}

.row-two {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 2rem;
    background-color: #202122;
    height: 169px;

    img {
        padding-right: 2rem;
    }
}

.row-two div {
    display: flex;
    align-items: flex-start;
    max-width: 35rem;

    margin-top: 5px;
    padding-right: 12px;
}
.opacity:hover {
    opacity: 0.7;
    cursor: pointer;
}
.row-two h2,
.row-three h2 {
    color: white;
    font-size: 24px;
    font-weight: 700;
}

.row-two p,
.row-three p {
    width: 18.373rem;
}

@media screen and (max-width: 425px) {
    .row-two {
        text-align: start;
    }
}

.row-two p {
    text-align: start;
    color: #ceceda;
}
.row-three p {
    text-align: start;
    color: #6f7381;
}

input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.row-three {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #202122;
    padding-left: 2.625rem;
    padding-top: 2.188rem;
    padding-bottom: 3.25rem;
    border: 1px solid transparent;
}
* {
    transition: 0s;
}
.main-row {
    display: flex;
    width: 100%;
    min-height: 420px;
    transition: 0s;
}
.main-row-info {
    min-height: 500px;
}
.main-row2 {
    margin-top: 40px;
}
.image-event {
    width: auto;
    max-width: 100%;
    display: none;
    max-height: 169px;
    // min-height: 139px;
}
.left,
.right {
    width: 50%;
    background-color: #171819;
    border: 0.5px solid #292a2e;
    //border-top: none;
}
.right {
    border-left: none;
}
.right-payment {
    transition: 0s !important;
    padding-left: 29px !important;
    padding-right: 29px !important;
    padding-top: 36px !important;
    display: flex;
    border-top: 0.5px solid #292a2e;
    flex-direction: column !important;
    justify-content: flex-start !important;
    position: relative !important;
    padding-bottom: 36px;
    p {
        margin: 0 15px;
        font-size: 13px;
    }
    @media screen and (max-width: 640px) {
        height: 300px;
        min-height: 300p !important;
    }
}

.left {
    padding-bottom: 1.5rem;
}

.right {
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 100%;

    div {
        width: 100%;
        max-height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .tour {
            &-img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }

            &-placeholder {
                object-fit: contain;
                width: 90%;
                height: 80%;
            }
        }
    }
}
.left-paypal {
    border-top: 0.5px solid #292a2e;
}
.block {
    display: flex;
    align-items: flex-start;
    //  padding-block: 1.875rem;
    padding-block: 1.075rem;
    color: $oc-gray;
    padding-left: 29px;
    flex-direction: column;
    padding-bottom: 0;
    transition: 0.5s;
    p:first-of-type {
        font-size: 13px;
    }

    &-with-border {
        padding-bottom: 0 !important;
    }

    .cont {
        display: flex;
        align-items: center;
        padding-bottom: 1.075rem;
        border-bottom: 0.5px solid #292a2e;
        .cont-header {
            color: #6f7381;
            font-size: 13px !important;
            font-weight: 600;
            text-wrap: nowrap;
        }
        p,
        a {
            font-size: 16px;
            color: #ceceda;
        }
        a {
            width: 85%;
            word-break: break-all;
        }

        &:last-child {
            font-size: 14px;
        }
    }

    //border-bottom: 1px solid $oc-gray;

    &-location {
        //border: 1px solid #c8a07d;
        //background-color: #1f201e;
        //padding-block: 3.625rem !important;

        //.cont {
        //    padding-bottom: 0 !important;
        //}

        p {
            font-weight: 500;

            &:first-of-type {
                margin-right: 0.95rem;
            }
        }
    }

    &-website {
        .cont {
            padding-bottom: 0;
        }
    }

    &-start {
        p {
            &:first-of-type {
                margin-right: 2.338rem;
            }
        }
    }

    &-end {
        p {
            &:first-of-type {
                margin-right: 2.875rem;
            }
        }
    }

    &-control {
        p {
            &:first-of-type {
                margin-right: 1rem;
            }
        }

        .btn {
            display: flex;
            background-color: #c8a07d;
            border-radius: 20px;
            justify-content: space-evenly;
            width: 7.813rem;
            padding-block: 0.2rem;
            color: white;

            p {
                font-weight: 500;
                font-size: 12px;
            }

            img,
            p {
                margin-right: 0;
            }
        }
    }

    &-website {
        a {
            color: #11c6d1;
            font-weight: 500;
        }
    }

    img {
        margin-right: 0.813rem;
    }
    svg {
        margin-right: 0.813rem;
    }
}
.btn-file {
    display: flex;
    border-radius: 20px;
    justify-content: space-evenly;
    width: 7.813rem;
    padding-block: 0.2rem;
    margin-left: 30px;

    // color: #11c6d1 !important;
    border: 0.5px solid #c8a07d;

    p {
        font-weight: 500;
        font-size: 12px;
    }

    img,
    p {
        margin-right: 0;
        font-weight: 600;
        color: white !important;
    }
}
.btn-file:hover {
    cursor: pointer !important;
    border: 0.5px solid #c8a07d;
    background-color: #c8a07d;

    transition: 0.3s;
}
a {
    color: #c8a07d !important;
    text-decoration: underline;
}

.dropdown {
    position: absolute;
    color: #ceceda;
    top: 38px;
    right: 28px;
    background-color: #171819;
    min-width: 145px;
    width: max-content;
    cursor: pointer;
    font-size: 14px;
    border: 0.5px solid rgba(92, 94, 100, 1);

    border-radius: 5px;
}
.tournament-desc {
    width: 100%;
    height: auto;

    p {
        margin-block: 1.438rem;
        padding: 1.5rem;
        padding-left: 49px;
        padding-right: 29px;
        color: #ceceda;
        background-color: #202122;
        font-size: 16px;
        font-family: "Red Hat Display", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        padding-bottom: 3rem;
        width: 100%;
        @media screen and (max-width: 640px) {
            padding-left: 29px !important;
        }
        p {
            a {
                color: #c8a07d !important;
            }
        }
    }
}

@media screen and (max-width: 1024px) {
    .main-row {
        flex-direction: column;
    }

    .left,
    .right {
        width: 100%;
    }
    .block {
        &-control {
            .btn {
                width: 12.813rem;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .parent {
        overflow-x: hidden;
    }

    .wrapper {
        width: 100%;
    }
    .right {
        display: none;
    }
    .right-payment {
        display: flex !important;
    }
    .right-payment-terms {
        height: 600px !important;
    }
    .main-div {
        width: 100%;
        justify-content: space-between;
        margin-bottom: 0;
        margin-top: 2.813rem;
    }

    .top p {
        text-align: center;
    }

    .row-one {
        padding-left: 2.333rem;
    }

    .row-two {
        padding-right: 2.333rem;
    }

    .main-row {
        margin-bottom: 0;
    }
}
.date-start {
    margin-left: 10px;
}
.date-end {
    margin-left: 14px;
}

@media screen and (max-width: 640px) {
    .mobile {
        display: flex !important;
        justify-content: flex-start;
        margin-top: 20px !important;
        margin-bottom: 0px;

        p {
            font-size: 14px !important;
            padding-left: 0px;
        }
        p:first-child {
            width: max-content !important;
        }
    }
    .players-registred {
        img {
            width: 24px !important;
        }
    }
    .desktop {
        display: none !important;
    }
    .main-row2 {
        margin-top: 12px;
    }
    .parent_correction {
        min-height: 100vh !important;
        padding-bottom: 50px;
    }
    .blue {
        font-size: 14px;
    }
    .checkboxFide {
        padding-right: 0px;
        display: flex;
    }
    .margin-gender {
        margin-right: 0px;
    }
    .input-registration {
        margin-left: 0px;
    }
    .left {
        border-bottom: none !important;
    }

    .confirm-button2 {
        height: 36px;
        width: 100px;
        margin-right: 15px;
        font-size: 16px;
    }
    .row-one-second {
        p {
            padding: 0 24px;
        }
    }
    .confirm-button2-cream {
        height: 36px;
        width: 100px;
        margin-right: 15px;
        color: #3a332d !important;
    }
    h2 {
        font-size: 20px !important;
    }
    .flexend-mobile {
        display: flex;

        margin-bottom: 0px;

        p {
            font-size: 14px;
        }
    }
    .flexend {
        display: none !important;
    }
    .signUpLetter {
        padding-left: 30px;
    }
    .date-start {
        margin-left: 16px;
    }
    .date-end {
        margin-left: 21px;
    }
    .bottom {
        padding-bottom: 70px;
    }
    p,
    a {
        font-size: 16px;
    }
    .row-two {
        padding-right: 1rem;
    }
    .block {
        padding-right: 10px;
        p:first-of-type {
            font-size: 16px;
        }
    }
    .pic-event-desktop {
        display: none !important;
    }
    .pic-event-mobile {
        display: block !important;
    }
    .wrapper {
        overflow-y: scroll;
        overflow-x: hidden;
        height: 100vh;
        margin-top: 1rem;
    }
    .mobile-header {
        display: flex;
        height: 4.6rem;
        width: 100%;
        justify-content: space-between;
        padding: 0 2.5rem;
        align-items: center;
        border-bottom: none !important;
        margin-bottom: 1.5rem;
    }

    .mobile-header > img {
        height: 2rem;
    }
    .main-div {
        margin-top: 0;
    }

    .row-one {
        display: none;
    }
    .row-two img {
        padding-right: 0;
        max-width: 10.833rem;
    }
    .row-two div {
        margin-top: 0px;

        padding-right: 2px;
    }
}

@media screen and (max-width: 425px) {
    .row-two img {
        max-width: 8.833rem;

        padding-right: 0;
    }
}

@media screen and (max-width: 375px) {
}

@media screen and (max-width: 320px) {
    .row-two {
        p {
            width: 13.3rem;
        }
    }
}
</style>
